<script>
import vue2Dropzone from "vue2-dropzone";
import CampaignApi from "@/services/campaign-api";
import ColorPickerField from "@/components/colorSelector";
import MenuApi from "@/services/menu-api";
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import Swal from "sweetalert2";
import { mapGetters } from 'vuex';


export default {
    components: {vue2Dropzone, ColorPickerField, Cropper},

    mounted() {
        this.findDetailsCampainById()
        this.$nextTick(() => {
            const mainContent = document.querySelector('.main-content')
            if (mainContent) {
            mainContent.style.overflow = 'visible'
            }
        })
    },
    computed: {
        isSupplier() {
         return this.$cookies.get('userr') == 1;
        },
        ...mapGetters('menu', ['menuCampaignId']),

    },

  data() {
    return {
        campaign: {id:null ,
                    isCollectingData:false ,
                    fieldsList:null, 
                    banner:null, 
                    rgb:"#FFFFFF",
                    rgbButton:"#FFFFFF",
                    description:null,
                    goals:null,
                    iosGoals:null,
                    displayButton:false,
                    textButton:null,
                    oAuth2:false,
                    oAuth2Facebook:false,
                    oAuth2Google:false,
                    rgbButtonText: "#FFFFFF",
                    rgbText: "#000000",
                    rgbButtonTextRangeAgeAndGender: "#000000",
                    menuCode:null,
                    isMenuCampaignWithOrder:false,
                    isMenuCampaignWithQuote:false,
                 },
        dropzoneOptions: {
            url: "/",
            addRemoveLinks: true,
            autoProcessQueue:false,
            maxFiles: 1,
            },

        titleConfig: {
        show: false,
        text:''
      },

      validateImageLoading:false,
      menu:{},
      showColorModalMenuBackgroundColor:false,
      showColorModalBannerTitleColor:false,
      showColorModalBannerSubTitleColor:false,
      showColorModalTitleColor:false,
      showColorModalMenuGroupColor:false,
      showColorModalMenuGroupTitleColor:false,
      showColorModalMenuSectionColor:false,
      showColorModalMenuSubSectionColor:false,
      showColorModalTitleProductColor:false,
      showItemdescriptionColor:false,
      showCardTitleItemBackgroundColor:false,
      openSections: {},
      openSubSections: {},
      menuGroups: [],
      menuSections: [],
      menuSubSections: [],
      showSectionModal:false,
      showGroupModal:false,
      selectedGroup:{id:null, name:null, menuId:null},
      selectedSection:{id:null, name:null, menuId:null},
      selectedSubSection:{id:null, name:null, menuId:null},
      showItemModal:false,
      showSubSectionModal:false,
      selectedItem:{id:null, name:null, menuId:null, sectionId:null},
      isImageReady:false,
      importedImage:null,
      importedImageUrl:null,
      imageName:null,
      oldImageName:null,
      maxFileSize:null,
      cropedImage:null,
      validateCropedImage:null,
      showCropedImageModal:null,
      selectedImage:null,
      prviewKey:null,
      saveError:null,
      fontSizes: ['12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '30px', '32px', '34px', '36px', '38px', '40px', '42px', '44px', '46px', '48px', '50px'],
      fontFamilies: [
        { font: 'Georgia', label: 'Georgia' },
        { font: 'Tahoma', label: 'Tahoma' },
        { font: 'Times New Roman', label: 'Times New Roman' },
        { font: 'Courier New', label: 'Courier New' },
        { font: 'Dancing Script', label: 'Cursive' },
        { font: 'Pacifico', label: 'Pacifico' },
        { font: 'Sour Gummy', label: 'Sour Gummy' },
        { font: 'Borel', label: 'Borel' },
        { font: 'Gilroy', label: 'Gilroy' }
        ],

      fontFamiliesAR: [
        { font: 'Amiri', label: 'أميري' },
        { font: 'Fustat', label: 'فسطاط' },
        { font: 'Katibeh', label: 'كاتبه' },
        { font: 'Lateef', label: 'لطيف' },
        { font: 'Mada', label: 'مدى' },
        { font: 'Marhey', label: 'مرحى' },
        { font: 'Markazi Text', label: 'مركزي' },
        { font: 'Noto Kufi Arabic', label: 'نوتو كوفي' },
        { font: 'Noto Sans Arabic', label: 'نوتو سانس' },
        { font: 'Scheherazade New', label: 'شهرزاد' },
        { font: 'Tajawal', label: 'تجول' },
        { font: 'Zain', label: 'زين' }
        ],

      languages: [ { code: 'fr', label: 'Français' },{ code: 'en', label: 'Anglais' }, { code: 'ar', label: 'Arabe' }],
      supportedLanguages: [ { code: 'fr', label: 'Français' }],

      defaultLanguage: null,
      showMenuItemImagePriorityAtIndex:null,
      showImagesModal:false,
      priorityImage:null,
      initialMenuItemPriorityImage:[],
      secondThumbnailFrame:null,

    };
  },


  watch:{
    menuCampaignId: function(){
        if(this.menuCampaignId){
            this.findDetailsCampainById()
        }
    },

    'selectedSubSection.sections'(val) {
      if (!val || val.length === 0) {
        this.selectedSubSection.sections = [this.selectedSection]
      }
    },

    'selectedItem.menuSubSection'(val) {
      if (!val || val.length === 0) {
        this.selectedItem.menuSubSection = [this.selectedSubSection]
      }
    }

  },

  methods: {

    initcampaign(){
        if(this.campaign && this.campaign.menuCode){
            this.getMenuByCode(this.campaign.menuCode)
            this.getAllMenuGroups(this.campaign.menuCode)
            this.getMenuSections(this.campaign.menuCode)
            this.getMenuSubSections(this.campaign.menuCode)
        }
    },

    getSubSectionId(selectedItem, selectedSubSection) {

        if (selectedItem.menuSubSection && selectedItem.menuSubSection.id) {
        return selectedItem.menuSubSection.id
        }

        if (selectedSubSection && selectedSubSection.id) {
        return selectedSubSection.id
        }

        return null
    },

    getLightDTO(items) {
      if (!items) return [];
      return items.map(item => ({
        id: item.id,
        name: item.name,
        nameFR: item.nameFR,
        nameEN: item.nameEN,
        nameAR: item.nameAR
      }));
    },

    getAllMenuGroups(codeMenu){
      MenuApi.getAllMenuGroups(codeMenu).then((result) => {
        this.menuGroups = result
      } )
    },

    cancelEditMenuItemImagePriority(){
        this.showMenuItemImagePriorityAtIndex = null,
        this.selectedItem.imagesPriority = [...this.initialMenuItemPriorityImage];
    },
    
    editImageMenuItem(selectedItem , imageName, priorityImage){
        this.showCropedImageModal = true
        this.importedImage = '' , 
        this.importedImageUrl = '/api/image/get/' + imageName
        this.isImageReady = true ,
        this.selectedItem=selectedItem 
        this.oldImageName= imageName
        this.priorityImage= priorityImage

    } ,

    
    changeMenuItemImagePriority(index){
        this.showMenuItemImagePriorityAtIndex = index
    },

    saveMenuItemImagepriority(imageName , index){
        const updatedMenuItemImagePriority={
            menuItemId : this.selectedItem.id,
            imageName :imageName,
            priority :  this.selectedItem.imagesPriority[index],        
        }


        MenuApi.updateMenuItemImagePriority(updatedMenuItemImagePriority).then(
            (result)=>{
                if(result){
                this.showMenuItemImagePriorityAtIndex = null
                this.$emit('refreshCampaign');

                }
            }
        )

    },

    isLangSupported(code) {
        return this.supportedLanguages.some(lang => lang.code === code);
    },


        showMenuItemsImageModal(item){
        if(item.id){
            this.selectedItem = item;
            this.initialMenuItemPriorityImage = [...item.imagesPriority]
        }
      this.showImagesModal=true
    },

    change({ canvas }) {
        canvas.toBlob((blob) => {
				this.cropedImage= blob
			}, "image/jpeg");
    },

    onImageUploadDragAndDrop(file) {
        this.importedImage=file;
        this.importedImageUrl = URL.createObjectURL(this.importedImage);
    },


    onImageUpload(event) {
       const image = event.target.files[0];
        this.onImageUploadDragAndDrop(image)
        this.showImagesModal=true
    },

    imageReady() {
        this.isImageReady = true;
    },

    closeSectionModal(){
        this.selectedSection={id:null, name:null},
        this.selectedSubSection={id:null, name:null},
        this.showSectionModal = false
        this.$emit('refreshCampaign');
    },

    closeSubSectionModal(){
        this.selectedSubSection={id:null, name:null},
        this.showSubSectionModal = false
        this.$emit('refreshCampaign');
    },

    closeGroupModal(){
        this.selectedGroup={id:null, name:null},
        this.showGroupModal = false
        this.$emit('refreshCampaign');
    },


    addNewSection(section){
        this.getMenuSubSections(this.campaign.menuCode)
        this.showSectionModal= true
        this.saveError= null
        if(section){
            this.selectedSection = section
        }
    },

    addNewGroup(group){
        this.showGroupModal= true
        this.saveError= null
        if(group){
            this.selectedGroup = group
        }
    },

    closeItemModal(){
        this.selectedSection={id:null, name:null, menuId:null},
        this.selectedSubSection={id:null, name:null},
        this.selectedItem={id:null, name:null, menuId:null, sectionId:null, itemNotAvailableOnline:false},
        this.selectedGroup={id:null, name:null, menuId:null, sectionId:null, priority:null},
        this.showItemModal = false
        this.validateCropedImage = null
        this.cropedImage = null
        this.importedImageUrl = null
        this.importedImage = null
        this.$emit('refreshCampaign');

    },

    showMenuItemsImageOrCropperModal(item, section) {
        if (section) {
            this.selectedSection = section;
            if (item) {
                this.selectedItem = item;
                if (item.image) {
                    this.showMenuItemsImageModal(item);
                } else {
                    this.openCropperImageModel(item);
                }
            }
        }
    },

    addNewItem(item , section, subSection){
        this.selectedItem={id:null, name:null, menuId:null, sectionId:null, menuSubSection:subSection},
        this.validateCropedImage = null
        this.cropedImage = null
        this.importedImageUrl = null
        this.importedImage = null

        if(section){
            this.showItemModal= true
            this.saveError= null
            this.selectedSection = section

            if(subSection){
                this.selectedSubSection = subSection
            }

            if(item){
                this.selectedItem = item
            }
        }
    },
    
    addNewSubSection(subSection, section){

        this.selectedSubSection={id:null, name:null, menuId:null, sectionId:section.id, sections: [section]},
        this.showSubSectionModal= true
        this.selectedSection = section

        if(subSection){
            this.selectedSubSection = subSection
        }

    },

    openCropperImageModel(item){
        if(item && item.id){
            this.selectedItem = item;
        }

        this.showCropedImageModal = true,
        this.importedImage = '' , 
        this.importedImageUrl = null,
        this.isImageReady = true, 
        this.oldImageName = null
        this.priorityImage = null
    },

    validateImage(){
        this.validateCropedImage = this.cropedImage
        this.addMenuItemImage()
        this.$emit('refreshCampaign');
    },

    changeMenuBackgroundColor({ color }) {
        this.menu.backgroundColor = this.rgbaToHex8(color)
    },

    changeBannerTitleColor({ color }) {

        this.menu.bannerTitleFontColor = this.rgbaToHex8(color)
    },

    changeBannerSubTitleColor({ color }) {
        this.menu.bannerSubTitleFontColor = this.rgbaToHex8(color)
    },

    changeTitleColor({ color }) {
        this.menu.titleFontColor = this.rgbaToHex8(color)
    },

    changeMenuGroupColor({ color }) {
        this.menu.groupFontColor = this.rgbaToHex8(color)
    },

    
    changeMenuGroupTitleColor({ color }) {
        this.menu.groupTitleColor = this.rgbaToHex8(color)
    },

    changeMenuSectionColor({ color }) {
        this.menu.sectionFontColor = this.rgbaToHex8(color)
    },

    changeMenuSubSectionColor({ color }) {
        this.menu.subSectionFontColor = this.rgbaToHex8(color)
    },

    changeTitleProductColor({ color }) {
        this.menu.productFontColor = this.rgbaToHex8(color)
    },

    changeItemDescriptionColor({ color }) {
        this.menu.itemDescriptionColor = this.rgbaToHex8(color)
    },

    changeTitleItemBackgroundColor({ color }) {
        this.menu.titleItemBackgroundColor = this.rgbaToHex8(color)
    },

    rgbaToHex8(color) {

        if (!color) return null
        const rgba = color.rgba || {}

        const r = rgba.r ?? 0
        const g = rgba.g ?? 0
        const b = rgba.b ?? 0
        const a = rgba.a ?? 1

        const toHex = v => Number(v).toString(16).padStart(2, '0')
        const alpha = Math.round(a * 255)

        const colorHex8 = (
            '#' +
                toHex(r) +
                toHex(g) +
                toHex(b) +
                toHex(alpha)
            ).toUpperCase()

        return colorHex8
    },



    /////////////////////
    ////   API CALL  ////
    /////////////////////

    findDetailsCampainById(){

        if(this.menuCampaignId == null ){
            return
        }

        CampaignApi.findDetailsCampainById(this.menuCampaignId).then(result =>{
            if(result){
                this.campaign = result
                this.selectedCity = this.campaign.cityDTOS	
                this.selectedCountry = this.campaign.countryDTO	
                this.selectedOptions = this.campaign.partnerNearsList	
                this.initcampaign()
            }
        })
    },

    getMenuSections(codeMenu){
      MenuApi.getMenuSections(codeMenu).then((result) => {
        this.menuSections = result
      } )
    },

    getMenuSubSections(codeMenu){
      MenuApi.getMenuSubSections(codeMenu).then((result) => {
        this.menuSubSections = result
      } )
    },

    savePriority(MenuItem){
        MenuApi.setMenuItemPriority(MenuItem.id , MenuItem.priority)
            .then((result)=>{
                this.itemChanged = result
                this.prviewKey++;
            })
    },
    
    removeGroup(group) {

    Swal.fire({
        title: "Supprimer la famille",
        html: `Êtes-vous sûr de vouloir supprimer la famille <strong>${group.name}</strong> ? <br><strong>La suppression de cette famille entraînera la suppression des affectations de toutes les catégories qui y sont rattachées.</strong>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#d11010",
        confirmButtonText: "Oui, supprimer",    
        cancelButtonText: "Annuler",
    }).then((result) => {
        if (result.value) {
        MenuApi.removeGroup(group.id).then(result => {
            if (result != null) {
                this.menuGroups = result;
                this.prviewKey++;
                this.showGroupModal= false
            }
        });
        }
    });
    },

    removeSection(section) {
    const hasItems = section.menuItem && section.menuItem.length > 0;

    Swal.fire({
        title: "Supprimer la catégorie",
        html: `Êtes-vous sûr de vouloir supprimer la catégorie <strong>${section.name}</strong> ?` +
            (hasItems ? "<br><strong>Tous les produits de cette catégorie et les affectation sous-catégorie qui y sont rattachées seront également supprimés définitivement</strong>" : ""),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#d11010",
        confirmButtonText: "Oui, supprimer",
        cancelButtonText: "Annuler",
    }).then((result) => {
        if (result.value) {
        MenuApi.removeSection(section.id).then(result => {
            if (result) {
            this.menu = result;
            this.prviewKey++;
            this.showSectionModal= false
            }
        });
        }
    });
    },
    
    removeSubSection(subSection, section) {
    const hasItems = section.menuItem && section.menuItem.length > 0;

    Swal.fire({
        title: "Supprimer la sous-catégorie",
        html: `Êtes-vous sûr de vouloir supprimer la sous-catégorie <strong>${subSection.name}</strong> ?` +
            (hasItems ? "<br><strong>Tous les produits de cette sous-catégorie seront également supprimés définitivement.</strong>" : ""),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#d11010",
        confirmButtonText: "Oui, supprimer",
        cancelButtonText: "Annuler",
    }).then((result) => {
        if (result.value) {
        MenuApi.removeSubSection(subSection.id, section.id).then(result => {
            if (result) {
            this.menu = result;
            this.prviewKey++;
            this.showSubSectionModal= false
            }
        });
        }
    });
    },

    removeItem(itemId) {
    Swal.fire({
        title: "Supprimer le produit",
        html: "Êtes-vous sûr de vouloir supprimer ce produit ?<br><strong>Cette action est irréversible.</strong>",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#d11010",
        confirmButtonText: "Oui, supprimer",
        cancelButtonText: "Annuler",
    }).then((result) => {
        if (result.value) {
        MenuApi.removeItem(itemId).then(result => {
            if (result) {
            this.menu = result;
            this.prviewKey++;
            this.showItemModal= false
            }
        });
        }
    });
    },

    saveSettingsMenu(){
        const settingsMenu = {
            id:this.menu.id,
            bannerTitleFR:this.menu.bannerTitleFR,
            bannerTitleEN:this.menu.bannerTitleEN,
            bannerTitleAR:this.menu.bannerTitleAR,
            bannerTitleFontSize:this.menu.bannerTitleFontSize,
            bannerTitleFontFamily:this.menu.bannerTitleFontFamily,

            bannerSubTitleFR:this.menu.bannerSubTitleFR,
            bannerSubTitleEN:this.menu.bannerSubTitleEN,
            bannerSubTitleAR:this.menu.bannerSubTitleAR,
            bannerSubTitleFontSize:this.menu.bannerSubTitleFontSize,
            bannerSubTitleFontFamily:this.menu.bannerSubTitleFontFamily,

            titleFR:this.menu.titleFR,
            titleEN:this.menu.titleEN,
            titleAR:this.menu.titleAR,
            titleFontSize:this.menu.titleFontSize,
            titleFontFamily:this.menu.titleFontFamilyOL,
            titleFontFamilyAR:this.menu.titleFontFamilyAR,
            titleFontWeight:this.menu.titleFontWeight,
            titleFontStyle:this.menu.titleFontStyle,
            titleTextDecoration:this.menu.titleTextDecoration,

            backgroundColor:this.menu.backgroundColor,
            bannerTitleFontColor:this.menu.bannerTitleFontColor,
            bannerSubTitleFontColor:this.menu.bannerSubTitleFontColor,
            titleFontColor:this.menu.titleFontColor,

            groupFontColor:this.menu.groupFontColor,
            groupTitleColor:this.menu.groupTitleColor,
            groupFontSize:this.menu.groupFontSize,
            groupFontFamily:this.menu.groupFontFamilyOL,
            groupFontFamilyAR:this.menu.groupFontFamilyAR,
            groupFontWeight:this.menu.groupFontWeight,
            groupFontStyle:this.menu.groupFontStyle,
            groupTextDecoration:this.menu.groupTextDecoration,

            sectionFontColor:this.menu.sectionFontColor,
            sectionFontSize:this.menu.sectionFontSize,
            sectionFontFamily:this.menu.sectionFontFamilyOL,
            sectionFontFamilyAR:this.menu.sectionFontFamilyAR,
            sectionFontWeight:this.menu.sectionFontWeight,
            sectionFontStyle:this.menu.sectionFontStyle,
            sectionTextDecoration:this.menu.sectionTextDecoration,


            subSectionFontColor:this.menu.subSectionFontColor,
            subSectionFontSize:this.menu.subSectionFontSize,
            subSectionFontFamily:this.menu.subSectionFontFamilyOL,
            subSectionFontFamilyAR:this.menu.subSectionFontFamilyAR,
            subSectionFontWeight:this.menu.subSectionFontWeight,
            subSectionFontStyle:this.menu.subSectionFontStyle,
            subSectionTextDecoration:this.menu.subSectionTextDecoration,


            productFontColor:this.menu.productFontColor,
            productFontSize:this.menu.productFontSize,
            productFontFamily:this.menu.productFontFamilyOL,
            productFontFamilyAR:this.menu.productFontFamilyAR,
            productFontWeight:this.menu.productFontWeight,
            productFontStyle:this.menu.productFontStyle,
            productTextDecoration:this.menu.productTextDecoration,
            titleItemBackgroundColor:this.menu.titleItemBackgroundColor,
            itemDescriptionColor:this.menu.itemDescriptionColor,

            instagramUrl:this.menu.instagramUrl,
            googleReviewUrl:this.menu.googleReviewUrl,

            defaultLanguages:this.defaultLanguage,
            supportedLanguages:this.supportedLanguages,
            campaignId:this.campaign.id,

        }

        MenuApi.saveSettingsMenu(settingsMenu).then(result => {
            if(result){
                this.menu = result ;
                this.prviewKey++;
                this.$emit('refreshCampaign');
            }
        })
       
    },

    deleteImage(){
        MenuApi.deleteMenuItemImage(this.oldImageName, this.selectedItem.id).then(result => {
            if (result) {
                this.selectedItem = result;
                this.showCropedImageModal = false;
                this.prviewKey++;
                this.$emit('refreshCampaign');
            }
        });
    },

    addMenuItemImage() {
    this.validateImageLoading = true

    const formData = new FormData();

    if (this.cropedImage != null) {
        formData.append("image", this.validateCropedImage);
    }

    if (this.oldImageName) {
        formData.append("oldImageName", this.oldImageName);
    }

    if (this.priorityImage) {
        formData.append("priorityImage", this.priorityImage);
    }

    if (this.cropedImage != null && this.importedImage && this.importedImage.name) {
        formData.append("imageName", this.importedImage.name);
    }

    if (this.menu?.id) {
        formData.append("menuId", this.menu.id);
    }

    if (this.selectedSection?.id) {
        formData.append("sectionId", this.selectedSection.id);
    }

    if (this.selectedSubSection?.id) {
        formData.append("subSectionId", this.selectedSubSection.id);
    }

    if (this.selectedItem?.id) {
        formData.append("id", this.selectedItem.id);
    }

    if (this.selectedItem?.isVisible != null) {
        formData.append("isVisible", this.selectedItem.isVisible);
    }
    
    MenuApi.addMenuItemImage(formData).then(result => {
        if (result) {
            Object.assign(this.selectedItem, result);
            this.showCropedImageModal = false;
            this.prviewKey++;
            this.validateImageLoading = false
        }
    }).finally(() => {
        this.validateImageLoading = false
    });
    },

    saveGroup(){

        if(this.supportedLanguages == null || this.supportedLanguages.length ==0){
            this.saveError = this.$t("campaign.label.menu.modal.errors.noSupportedLanguages");
              setTimeout(() => {
                this.saveError = null;
            }, 3000);

            return;
        }

        this.selectedGroup.menuId = this.menu.id
        this.selectedGroup.campaignId = this.campaign.id
        MenuApi.saveGroup(this.selectedGroup).then(result => {
            if(result){
              this.menuGroups = result
              this.showGroupModal = false

            }
        })
    },

    saveSection(){

        if(this.supportedLanguages == null || this.supportedLanguages.length ==0){
            this.saveError = this.$t("campaign.label.menu.modal.errors.noSupportedLanguages");
              setTimeout(() => {
                this.saveError = null;
            }, 3000);

            return;
        }

        this.selectedSection.menuId = this.menu.id
        this.selectedSection.campaignId = this.campaign.id
        MenuApi.saveSection(this.selectedSection).then(result => {
            if(result){
                this.menu = result ;
                this.prviewKey++;
                this.showSectionModal = false
                this.$emit('refreshCampaign');
            }
        })
    },

    saveSubSection(){

        if(this.supportedLanguages == null || this.supportedLanguages.length ==0){
            this.saveError = this.$t("campaign.label.menu.modal.errors.noSupportedLanguages");
              setTimeout(() => {
                this.saveError = null;
            }, 3000);

            return;
        }

        this.selectedSubSection.menuId = this.menu.id
        this.selectedSubSection.campaignId = this.campaign.id
        MenuApi.saveSubSection(this.selectedSubSection).then(result => {
            if(result){
                this.menu = result ;
                this.prviewKey++;
                this.showSubSectionModal = false
                this.$emit('refreshCampaign');
            }
        })
    },

    saveItem(sectionId, itemId, subSectionId) {
        
        if(this.supportedLanguages == null || this.supportedLanguages.length ==0){
            this.saveError = this.$t("campaign.label.menu.modal.errors.noSupportedLanguages");
              setTimeout(() => {
                this.saveError = null;
            }, 3000);

            return;
        }

        const item = this.selectedItem;
        const data = {
            nameFR: item.nameFR ?? null,
            nameEN: item.nameEN ?? null,
            nameAR: item.nameAR ?? null,
            price: item.priceAsFloat ?? null,
            descriptionFR: item.descriptionFR ?? null,
            descriptionEN: item.descriptionEN ?? null,
            descriptionAR: item.descriptionAR ?? null,
            priority: item.priority ?? null,
            isVisible: item.isVisible ?? null,
            isNotAvailableOnline: item.isNotAvailableOnline ?? null,
            isNotAvailableVirtual: item.isNotAvailableVirtual ?? null,
            isHiddenOnline: item.isHiddenOnline ?? null,
            menuId: this.menu?.id ?? null,
            sectionId: sectionId,
            subSectionId: subSectionId,
            id: itemId ?? null,
        };

        MenuApi.saveItem(data).then(result => {
            if (result) {
                this.menu = result;
                this.prviewKey++;
                this.showItemModal= false
            }
        });
    },

    getMenuByCode(menuCode) {
      MenuApi.getMenuByCode(menuCode).then((result) => {
        if (result) {
          this.menu = result;

            const supportedCodes = result.supportedLanguages;

            if (Array.isArray(supportedCodes)) {
                this.supportedLanguages = this.languages
                .filter(lang => supportedCodes.includes(lang.code))
                .sort((a, b) => supportedCodes.indexOf(a.code) - supportedCodes.indexOf(b.code));
                this.defaultLanguage = this.supportedLanguages[0];
            } else {
                this.supportedLanguages = [];
                this.defaultLanguage = null;
            }

        }
      });
    },
    
    saveThumbnailImageMenu(){

        const formData = new FormData();
        const thumbnailImage=this.$refs.thumbnailImageDropzone.getAcceptedFiles()[0]
        if (thumbnailImage) {
            formData.append('image', thumbnailImage);
            if (this.campaign != null && this.campaign.id) formData.append('campaignId', this.campaign.id);
            if (this.menu != null && this.menu.id) formData.append('menuId', this.menu.id);
            formData.append('imageName', thumbnailImage.name);
        }
        
        MenuApi.saveThumbnailImageMenu(formData).then(result => {
            if (result) {
                this.menu = result;
                this.prviewKey++;
                this.$emit('refreshCampaign');
            }
        });

    },

    removeBannerMenu(isThumbnail){

        if(this.menu == null || this.menu.id == null){
            return;
        }

        Swal.fire({
            title: isThumbnail ? "Supprimer Bannière Publicitaire thumbnail" : "Supprimer Bannière Publicitaire",
            html: "Êtes-vous sûr de vouloir supprimer la bannière",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#d11010",
            confirmButtonText: "Oui, supprimer",
            cancelButtonText: "Annuler",
        }).then((result) => {
            if (result.value) {
                MenuApi.removeBannerMenu(this.menu.id, isThumbnail).then(result => {
                    if (result) {
                        this.menu = result;
                        this.prviewKey++;
                        this.$emit('refreshCampaign');
                    }
                });
            }
        });

    },

    saveBannerMenu(){

        const formData = new FormData();

        const menuBanner=this.$refs.myMenuVueDropzone.getAcceptedFiles()[0]
        if (menuBanner) {
            formData.append('image', menuBanner);
            if (this.campaign != null && this.campaign.id) formData.append('campaignId', this.campaign.id);
            if (this.menu != null && this.menu.id) formData.append('menuId', this.menu.id);
            formData.append('imageName', menuBanner.name);
        }
        
        MenuApi.saveBannerMenu(formData, this.secondThumbnailFrame).then(result => {
            if (result) {
                this.menu = result;
                this.prviewKey++;
                this.$emit('refreshCampaign');
            }
        });

    },

  },
};
</script>

<template>
    <div v-if="campaign.isMenuCampaign || isSupplier ">

        <div class="row">
            <div class="col-xl-9 col-lg-8 col-12 pr-2">
                <div class="card h-100">
                    <div class="card-body ">

                        <div>
                            <h2 class="card-title font-size-25 text-uppercase text-dark" style="font-size:25px;">Parametrage du Menu </h2>
                        </div>

                        <div class="mt-3 "> 

                            <b-tabs  nav-class="nav-tabs-custom" content-class="mt-3 text-muted" active-nav-item-class="font-weight-bold text-uppercase ">

                                <b-tab>
                                    <template v-slot:title>
                                        <span class="font-size-16">{{$t('campaign.label.image')}}</span>
                                    </template>

                                    <div class="mx-4 row ">
                                        <div class="col-12 text-left">
                                            <div class="row pb-4 font-size-16 mt-4">
                                                <div class="col-12 text-uppercase font-weight-bold text-info bg-light">1. {{$t('campaign.label.image')}} </div>
                                            </div>
                                        </div>

                                        <div class="col-md-6 col-12 text-center">
                                            <b-form-group class="text-dark font-weight-bold" :label="$t('campaign.text.bannerImageVideoType')" label-for="" :disabled="campaign.id == null"  >
                                                <vue2Dropzone class="m-0 p-0 m-md-2 p-md-1" id="dropzone" ref="myMenuVueDropzone" maxFileSizeInMB="1" maxNumberOfFiles="1" :use-custom-slot="true" :options="dropzoneOptions">
                                                    <div class="dropzone-custom-content text-center p-3">
                                                    <img   alt=""  width="80px"  src="@/assets/icons/cloud-upload.svg"  />  
                                                        <h4 class="mb-0">{{ $t('parameters.dropImage') }}</h4>
                                                        <h5 class="text-warning font-size-9 text-Center mt-1" >{{ $t('parameters.imageSize') }} </h5>
                                                    </div>
                                                </vue2Dropzone>
                                            </b-form-group>     
                                        </div>
                                        <div v-if="menu.image" class="col-md-6 col-12 my-auto text-center">
                                            <video   v-if="menu.bannerMediaType === 1" style="max-width: 400px;" width="100%" height="auto" controls >
                                            <source :src="'/api/image/get/' + menu.image" type="video/mp4" />
                                            Votre navigateur ne supporte pas la lecture de vidéos.
                                            </video>

                                            <img    alt=""  style="max-width: 400px;"  width="100%"  height="auto"  :src="'/api/image/get/' + menu.image" />
                                        </div>

                                    </div>

                                    <div>
                                    <b-form-group
                                        :label="$t('campaign.label.menu.secondThumbnailFrameLabel')"
                                        label-for="secondThumbnailFrame"
                                        :description="$t('campaign.label.menu.secondThumbnailFrameDescription')"
                                    >
                                        <b-form-input
                                        id="secondThumbnailFrame"
                                        v-model="secondThumbnailFrame"
                                        type="number"
                                        min="0"
                                        :placeholder="$t('campaign.label.menu.secondThumbnailFrameEx')"
                                        ></b-form-input>
                                    </b-form-group>
                                    </div>

                                    <div class="mt-4 col-12 text-right">
                                        <b-button variant="primary" @click="saveBannerMenu()" class="float-sm-right font-weight-bold text-uppercase mt-4 mt-lg-0 mt-xl-0 mt-md-0 ml-2" :disabled="campaign.id == null ">
                                            {{$t("buttons.import")}}
                                        </b-button> 
                                        <b-button variant="danger" @click="removeBannerMenu()" class="float-sm-right font-weight-bold text-uppercase mt-4 mt-lg-0 mt-xl-0 mt-md-0 mr-2" :disabled="campaign.id == null || menu.image ==null ">
                                            {{$t("buttons.delete")}}
                                        </b-button>
                                    </div>


                                    <div class="col-12 row ">

                                        <div class="col-12 text-left">
                                            <div class="row pb-4 font-size-16 mt-4">
                                                <div class="col-12 text-uppercase font-weight-bold text-info bg-light">2. {{$t('campaign.label.thumbnailImage')}} </div>
                                            </div>
                                        </div>

                                        <div class="col-md-6 col-12 text-center">
                                            <b-form-group class="text-dark font-weight-bold" :label="$t('campaign.text.bannerType')" label-for="" :disabled="campaign.id == null"  >
                                                <vue2Dropzone class="m-0 p-0 m-md-2 p-md-1" id="thumbnailImageDropzoneId" ref="thumbnailImageDropzone" maxFileSizeInMB="1" maxNumberOfFiles="1" :use-custom-slot="true" :options="dropzoneOptions">
                                                    <div class="dropzone-custom-content text-center p-3">
                                                    <img   alt=""  width="80px"  src="@/assets/icons/cloud-upload.svg"  />  
                                                        <h4 class="mb-0">{{ $t('parameters.dropImage') }}</h4>
                                                        <h5 class="text-warning font-size-9 text-Center mt-1" >{{ $t('parameters.imageSize') }} </h5>
                                                    </div>
                                                </vue2Dropzone>
                                            </b-form-group>     
                                        </div>
                                        <div v-if="menu.thumbnailImage" class="col-md-6 col-12 my-auto text-center">
                                            <img    alt=""  style="max-width: 400px;"  width="100%"  height="auto"  :src="'/api/image/get/' + menu.thumbnailImage" />
                                        </div>

                                    </div>

                                    <div class="mt-4 col-12 text-right">
                                        <b-button variant="primary" @click="saveThumbnailImageMenu()" class="float-sm-right font-weight-bold text-uppercase mt-4 mt-lg-0 mt-xl-0 mt-md-0 ml-2" :disabled="campaign.id == null ">
                                            {{$t("buttons.import")}}
                                        </b-button> 
                                        <b-button variant="danger" @click="removeBannerMenu(true)" class="float-sm-right font-weight-bold text-uppercase mt-4 mt-lg-0 mt-xl-0 mt-md-0 mr-2" :disabled="campaign.id == null || menu.thumbnailImage == null ">
                                            {{$t("buttons.delete")}}
                                        </b-button>
                                    </div>


                                </b-tab>

                                <b-tab>
                                    <template v-slot:title>
                                        <span class="font-size-16">{{$t('campaign.label.menu.generalSettings')}}</span>
                                    </template>

                                    <div class="mx-4 ">
                                        <!-- LANGUAGES -->
                                        <div class="text-left">
                                            <div class="row pb-2 font-size-16 mt-4">
                                                <div class="col-12 text-uppercase font-weight-bold text-info "> {{$t('campaign.label.menu.language')}} </div>
                                            </div>
                                        </div>

                                        <div class="mx-4 mt-2">
                                            <div class="row">
                                                <div class="col-md-5 pr-md-2 pr-0">
                                                <label for="supportedLangs" class="text-uppercase font-weight-bold text-dark font-size-14 ">{{$t('campaign.label.menu.supportedLanguage')}}</label>
                                                    <v-select
                                                        class="style-vselect-big-qr-setting"
                                                        v-model="supportedLanguages"
                                                        :options="languages"
                                                        :multiple="true"
                                                        label="label"
                                                        :placeholder="$t('campaign.label.menu.placeholder.supportedLanguage')"
                                                        :disabled="campaign.id == null "
                                                    />
                                                </div>

                                                <div class="col-md-5 pl-md-2 pl-0 pt-md-0 pt-3">
                                                <label for="defaultLang" class="text-uppercase font-weight-bold text-dark font-size-14 ">{{$t('campaign.label.menu.defaultLanguage')}}</label>
                                                <v-select
                                                    :disabled="supportedLanguages == null || supportedLanguages.length == 0"
                                                    class="style-vselect-big-qr-setting"
                                                    id="defaultLang"
                                                    v-model="defaultLanguage"
                                                    :options="supportedLanguages"
                                                    label="label"
                                                    :placeholder="$t('campaign.label.menu.defaultLanguage')"
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <!-- TITLE PAGE -->
                                        <div class="container-fluid">
                                            <!-- Title Page Section -->

                                            <div class="col-md-12 col-12 text-left">

                                                <div class="row pb-2 font-size-16 mt-5">
                                                    <div class="col-12 text-uppercase font-weight-bold text-info ">{{$t('campaign.label.menu.titlePage')}}</div>
                                                </div>
                                            </div>

                                            <!-- Style Section -->
                                            <div class="row pb-2 mt-3">
                                                <div class="col-12 text-uppercase font-weight-bold text-dark">Style</div>
                                            </div>

                                            <div class="row">
                                                <!-- Font Size -->
                                                <div class="col-md-3 col-12">
                                                    <b-form-select
                                                        id="fontSizeSelect"
                                                        v-model="menu.titleFontSize"
                                                        :options="fontSizes"
                                                        placeholder="Sélectionnez une taille"
                                                        :disabled="campaign.id == null"
                                                    ></b-form-select>
                                                </div>

                                                <!-- Font Family (Latin) -->
                                                <div class="col-xl-3 col-md-6 col-12 pl-md-2 pl-0 pt-md-0 pt-3">
                                                    <b-form-group class="w-100 mb-0">
                                                    <v-select
                                                        v-model="menu.titleFontFamilyOL"
                                                        :options="fontFamilies"
                                                        label="label"
                                                        :reduce="option => option.font"
                                                        placeholder="Sélectionnez une police (Latin)"
                                                        class="style-vselect-big-qr-setting"
                                                        :disabled="campaign.id == null "
                                                    >
                                                        <template #option="{ label, font }">
                                                        <div :style="{ fontFamily: font }">
                                                            {{ label }}
                                                        </div>
                                                        </template>

                                                        <template #selected-option="{ label, font }">
                                                        <div :style="{ fontFamily: font }">
                                                            {{ label }}
                                                        </div>
                                                        </template>
                                                    </v-select>
                                                    </b-form-group>
                                                </div>

                                                <!-- Font Family (Arabic) -->
                                                <div class="col-xl-3 col-md-6 col-12 pl-md-2 pl-0 pt-md-0 pt-3"  v-if="isLangSupported('ar')">
                                                    <b-form-group class="w-100 mb-0">
                                                    <v-select
                                                        v-model="menu.titleFontFamilyAR"
                                                        :options="fontFamiliesAR"
                                                        label="label"
                                                        :reduce="option => option.font"
                                                        placeholder="Sélectionnez une police (Arabe)"
                                                        class="style-vselect-big-qr-setting-ar"
                                                        :disabled="campaign.id == null "
                                                    >
                                                        <template #option="{ label, font }">
                                                        <div :style="{ fontFamily: font }">
                                                            {{ label }}
                                                        </div>
                                                        </template>

                                                        <template #selected-option="{ label, font }">
                                                        <div :style="{ fontFamily: font }">
                                                            {{ label }}
                                                        </div>
                                                        </template>
                                                    </v-select>
                                                    </b-form-group>
                                                </div>

                                                <div class="col-12 mt-3">
                                                    <div class="row">
                                                        <!-- Font Weight -->
                                                        <div class="mr-2 mb-3">
                                                            <span class="btn-group shadow-sm rounded-3">
                                                            <button
                                                                
                                                                style="height: 2.2rem;"
                                                                class="btn btn-sm"
                                                                :class="menu.titleFontWeight === 'normal' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                @click="menu.titleFontWeight = 'normal'"
                                                            >
                                                                <i class="fas fa-font pr-1"></i>
                                                                <strong>Normal</strong>
                                                            </button>
                                                            <button
                                                                
                                                                style="height: 2.2rem;"
                                                                class="btn btn-sm"
                                                                :class="menu.titleFontWeight === 'bold' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                @click="menu.titleFontWeight = 'bold'"
                                                            >
                                                                <i class="fas fa-bold pr-1"></i>
                                                                <strong>Gras</strong>
                                                            </button>
                                                            </span>
                                                        </div>

                                                        <!-- Text Decoration -->
                                                        <div class="mr-2 mb-3">
                                                            <span class="btn-group shadow-sm rounded-3">
                                                            <button
                                                                
                                                                style="height: 2.2rem;"
                                                                class="btn btn-sm"
                                                                :class="menu.titleTextDecoration === 'none' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                @click="menu.titleTextDecoration = 'none'"
                                                            >
                                                                <i class="fas fa-ban pr-1"></i>
                                                                <strong>Normal</strong>
                                                            </button>
                                                            <button
                                                                
                                                                style="height: 2.2rem;"
                                                                class="btn btn-sm"
                                                                :class="menu.titleTextDecoration === 'underline' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                @click="menu.titleTextDecoration = 'underline'"
                                                            >
                                                                <i class="fas fa-underline pr-1"></i>
                                                                <strong>Souligné</strong>
                                                            </button>
                                                            </span>
                                                        </div>

                                                        <!-- Font Style -->
                                                        <div class=" mb-3">
                                                            <span class="btn-group shadow-sm rounded-3">
                                                            <button
                                                                
                                                                style="height: 2.2rem;"
                                                                class="btn btn-sm"
                                                                :class="menu.titleFontStyle === 'normal' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                @click="menu.titleFontStyle = 'normal'"
                                                            >
                                                                <i class="fas fa-font pr-1"></i>
                                                                <strong>Normal</strong>
                                                            </button>
                                                            <button
                                                                
                                                                style="height: 2.2rem;"
                                                                class="btn btn-sm"
                                                                :class="menu.titleFontStyle === 'italic' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                @click="menu.titleFontStyle = 'italic'"
                                                            >
                                                                <i class="fas fa-italic pr-1"></i>
                                                                <strong>Italique</strong>
                                                            </button>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Text Section -->
                                            <div class="row pb-2 mt-3">
                                                <div class="col-12 text-uppercase font-weight-bold text-dark">Texte</div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-4 pr-md-2 pr-0 " v-if="isLangSupported('fr')">
                                                    <b-form-group class="w-100 mb-0">
                                                        <b-input-group class="h-100">
                                                        <b-form-input
                                                            :placeholder="$t('campaign.label.menu.titlePageFR')" 
                                                            :disabled="campaign.id == null "
                                                            v-model="menu.titleFR"
                                                            class="h-100"
                                                        />
                                                        </b-input-group>
                                                    </b-form-group>
                                                </div>

                                                <div class="col-md-4 pr-md-2 pr-0  pt-md-0 pt-3" v-if="isLangSupported('en')">
                                                    <b-form-group class="w-100 mb-0">
                                                        <b-input-group class="h-100">
                                                        <b-form-input
                                                            :placeholder="$t('campaign.label.menu.titlePageEN')" 
                                                            :disabled="campaign.id == null "
                                                            v-model="menu.titleEN"
                                                            class="h-100"
                                                        />
                                                        </b-input-group>
                                                    </b-form-group>
                                                </div>

                                                <div class="col-md-4 pr-md-2 pr-0  pt-md-0 pt-3" v-if="isLangSupported('ar')">
                                                    <b-form-group class="w-100 mb-0">
                                                        <b-input-group class="h-100">
                                                        <b-form-input
                                                            :placeholder="$t('campaign.label.menu.titlePageAR')" 
                                                            :disabled="campaign.id == null "
                                                            v-model="menu.titleAR"
                                                            class="h-100"
                                                        />
                                                        </b-input-group>
                                                    </b-form-group>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- MENU GROUP -->
                                        <div class="container-fluid">
                                            <!-- Title Page Section -->

                                            <div class="col-md-12 col-12 text-left">
                                                <div class="row pb-2 font-size-16 mt-5">
                                                    <div class="col-12 text-uppercase font-weight-bold text-info ">{{$t('campaign.label.menu.groupTitle')}}</div>
                                                </div>
                                            </div>

                                            <!-- Style Section -->
                                            <div class="row pb-2 mt-3">
                                                <div class="col-12 text-uppercase font-weight-bold text-dark">Style</div>
                                            </div>

                                            <div class="row">
                                                <!-- Font Size -->
                                                <div class="col-md-3 col-12">
                                                    <b-form-select
                                                        id="fontSizeSelect"
                                                        v-model="menu.groupFontSize"
                                                        :options="fontSizes"
                                                        placeholder="Sélectionnez une taille"
                                                        :disabled="campaign.id == null"
                                                    ></b-form-select>
                                                </div>

                                                <!-- Font Family (Latin) -->
                                                <div class="col-xl-3 col-md-6 col-12 pl-md-2 pl-0 pt-md-0 pt-3">
                                                    <b-form-group class="w-100 mb-0">
                                                    <v-select
                                                        v-model="menu.groupFontFamilyOL"
                                                        :options="fontFamilies"
                                                        label="label"
                                                        :reduce="option => option.font"
                                                        placeholder="Sélectionnez une police (Latin)"
                                                        class="style-vselect-big-qr-setting"
                                                        :disabled="campaign.id == null "
                                                    >
                                                        <template #option="{ label, font }">
                                                        <div :style="{ fontFamily: font }">
                                                            {{ label }}
                                                        </div>
                                                        </template>

                                                        <template #selected-option="{ label, font }">
                                                        <div :style="{ fontFamily: font }">
                                                            {{ label }}
                                                        </div>
                                                        </template>
                                                    </v-select>
                                                    </b-form-group>
                                                </div>

                                                <!-- Font Family (Arabic) -->
                                                <div class="col-xl-3 col-md-6 col-12 pl-md-2 pl-0 pt-md-0 pt-3"  v-if="isLangSupported('ar')">
                                                    <b-form-group class="w-100 mb-0">
                                                    <v-select
                                                        v-model="menu.groupFontFamilyAR"
                                                        :options="fontFamiliesAR"
                                                        label="label"
                                                        :reduce="option => option.font"
                                                        placeholder="Sélectionnez une police (Arabe)"
                                                        class="style-vselect-big-qr-setting-ar"
                                                        :disabled="campaign.id == null "
                                                    >
                                                        <template #option="{ label, font }">
                                                        <div :style="{ fontFamily: font }">
                                                            {{ label }}
                                                        </div>
                                                        </template>

                                                        <template #selected-option="{ label, font }">
                                                        <div :style="{ fontFamily: font }">
                                                            {{ label }}
                                                        </div>
                                                        </template>
                                                    </v-select>
                                                    </b-form-group>
                                                </div>

                                                <div class="col-12 mt-3">
                                                    <div class="row">
                                                        <!-- Font Weight -->
                                                        <div class="mr-2 mb-3">
                                                            <span class="btn-group shadow-sm rounded-3">
                                                            <button
                                                                
                                                                style="height: 2.2rem;"
                                                                class="btn btn-sm"
                                                                :class="menu.groupFontWeight === 'normal' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                @click="menu.groupFontWeight = 'normal'"
                                                            >
                                                                <i class="fas fa-font pr-1"></i>
                                                                <strong>Normal</strong>
                                                            </button>
                                                            <button
                                                                
                                                                style="height: 2.2rem;"
                                                                class="btn btn-sm"
                                                                :class="menu.groupFontWeight === 'bold' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                @click="menu.groupFontWeight = 'bold'"
                                                            >
                                                                <i class="fas fa-bold pr-1"></i>
                                                                <strong>Gras</strong>
                                                            </button>
                                                            </span>
                                                        </div>

                                                        <!-- Text Decoration -->
                                                        <div class="mr-2 mb-3">
                                                            <span class="btn-group shadow-sm rounded-3">
                                                            <button
                                                                
                                                                style="height: 2.2rem;"
                                                                class="btn btn-sm"
                                                                :class="menu.groupTextDecoration === 'none' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                @click="menu.groupTextDecoration = 'none'"
                                                            >
                                                                <i class="fas fa-ban pr-1"></i>
                                                                <strong>Normal</strong>
                                                            </button>
                                                            <button
                                                                
                                                                style="height: 2.2rem;"
                                                                class="btn btn-sm"
                                                                :class="menu.groupTextDecoration === 'underline' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                @click="menu.groupTextDecoration = 'underline'"
                                                            >
                                                                <i class="fas fa-underline pr-1"></i>
                                                                <strong>Souligné</strong>
                                                            </button>
                                                            </span>
                                                        </div>

                                                        <!-- Font Style -->
                                                        <div class=" mb-3">
                                                            <span class="btn-group shadow-sm rounded-3">
                                                            <button
                                                                
                                                                style="height: 2.2rem;"
                                                                class="btn btn-sm"
                                                                :class="menu.groupFontStyle === 'normal' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                @click="menu.groupFontStyle = 'normal'"
                                                            >
                                                                <i class="fas fa-font pr-1"></i>
                                                                <strong>Normal</strong>
                                                            </button>
                                                            <button
                                                                
                                                                style="height: 2.2rem;"
                                                                class="btn btn-sm"
                                                                :class="menu.groupFontStyle === 'italic' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                @click="menu.groupFontStyle = 'italic'"
                                                            >
                                                                <i class="fas fa-italic pr-1"></i>
                                                                <strong>Italique</strong>
                                                            </button>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12 col-12 text-left">
                                            <div class="row pb-2 font-size-16 mt-5">
                                                <div class="col-12 text-uppercase font-weight-bold text-info "> {{$t('campaign.label.menu.sectionTitle')}}</div>
                                            </div>
                                        </div>

                                        <div>
                                            <div class="col-12 text-left">
                                                <div class="row pb-2 font-size-14">
                                                    <div class="col-12 text-uppercase font-weight-bold text-dark">style </div>
                                                </div>
                                            </div>

                                            <div class="col-md-12 col-12 text-left">
                                                <div class="row">
                                                    <div class="col-xl-3 col-md-6 col-12 pr-md-2 pr-0">
                                                        <b-form-group class="w-100 mb-0">
                                                        <v-select
                                                            v-model="menu.sectionFontSize"
                                                            :options="fontSizes"
                                                            placeholder="Sélectionnez une taille"
                                                            class="style-vselect-big-qr-setting"
                                                            :disabled="campaign.id == null "
                                                        />
                                                        </b-form-group>
                                                    </div>

                                                    <div class="col-xl-3 col-md-6 col-12 pl-md-2 pl-0 pt-md-0 pt-3">
                                                        <b-form-group class="w-100 mb-0">
                                                        <v-select
                                                            v-model="menu.sectionFontFamilyOL"
                                                            :options="fontFamilies"
                                                            label="label"
                                                            :reduce="option => option.font"
                                                            placeholder="Sélectionnez une police (Latin)"
                                                            class="style-vselect-big-qr-setting"
                                                            :disabled="campaign.id == null "
                                                            >
                                                            <template #option="{ label, font }">
                                                                <div :style="{ fontFamily: font }">
                                                                {{ label }}
                                                                </div>
                                                            </template>

                                                            <template #selected-option="{ label, font }">
                                                                <div :style="{ fontFamily: font }">
                                                                {{ label }}
                                                                </div>
                                                            </template>
                                                            </v-select>

                                                        </b-form-group>
                                                    </div>

                                                    <div class="col-xl-3 col-md-6 col-12 pl-md-2 pl-0 pt-md-0 pt-3" v-if="isLangSupported('ar')">
                                                        <b-form-group class="w-100 mb-0">
                                                        <v-select
                                                            v-model="menu.sectionFontFamilyAR"
                                                            :options="fontFamiliesAR"
                                                            label="label"
                                                            :reduce="option => option.font"
                                                            placeholder="Sélectionnez une police (Arabe)"
                                                            class="style-vselect-big-qr-setting-ar"
                                                            :disabled="campaign.id == null "
                                                            >
                                                            <template #option="{ label, font }">
                                                                <div :style="{ fontFamily: font }">
                                                                {{ label }}
                                                                </div>
                                                            </template>

                                                            <template #selected-option="{ label, font }">
                                                                <div :style="{ fontFamily: font }">
                                                                {{ label }}
                                                                </div>
                                                            </template>
                                                            </v-select>

                                                        </b-form-group>
                                                    </div>
                                                    
                                                    <div class="col-12 mt-3">
                                                        <div class="row">
                                                            <!-- Font Weight -->
                                                            <div class="mr-2 mb-3">
                                                                <span class="btn-group shadow-sm rounded-3">
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.sectionFontWeight === 'normal' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.sectionFontWeight = 'normal'"
                                                                >
                                                                    <i class="fas fa-font pr-1"></i>
                                                                    <strong>Normal</strong>
                                                                </button>
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.sectionFontWeight === 'bold' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.sectionFontWeight = 'bold'"
                                                                >
                                                                    <i class="fas fa-bold pr-1"></i>
                                                                    <strong>Gras</strong>
                                                                </button>
                                                                </span>
                                                            </div>

                                                            <!-- Text Decoration -->
                                                            <div class="mr-2 mb-3">
                                                                <span class="btn-group shadow-sm rounded-3">
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.sectionTextDecoration === 'none' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.sectionTextDecoration = 'none'"
                                                                >
                                                                    <i class="fas fa-ban pr-1"></i>
                                                                    <strong>Normal</strong>
                                                                </button>
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.sectionTextDecoration === 'underline' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.sectionTextDecoration = 'underline'"
                                                                >
                                                                    <i class="fas fa-underline pr-1"></i>
                                                                    <strong>Souligné</strong>
                                                                </button>
                                                                </span>
                                                            </div>

                                                            <!-- Font Style -->
                                                            <div class=" mb-3">
                                                                <span class="btn-group shadow-sm rounded-3">
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.sectionFontStyle === 'normal' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.sectionFontStyle = 'normal'"
                                                                >
                                                                    <i class="fas fa-font pr-1"></i>
                                                                    <strong>Normal</strong>
                                                                </button>
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.sectionFontStyle === 'italic' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.sectionFontStyle = 'italic'"
                                                                >
                                                                    <i class="fas fa-italic pr-1"></i>
                                                                    <strong>Italique</strong>
                                                                </button>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12 col-12 text-left">

                                            <div class="row pb-2 font-size-16 mt-5">
                                                <div class="col-12 text-uppercase font-weight-bold text-info "> {{$t('campaign.label.menu.subSectionTitle')}}</div>
                                            </div>
                                        </div>


                                        <div>

                                            <div class="col-12 text-left">
                                                <div class="row pb-2 font-size-14">
                                                    <div class="col-12 text-uppercase font-weight-bold text-dark">style </div>
                                                </div>
                                            </div>

                                            <div class="col-md-12 col-12 text-left">
                                                <div class="row">
                                                    <div class="col-xl-3 col-md-6 col-12 pr-md-2 pr-0">
                                                        <b-form-group class="w-100 mb-0">
                                                        <v-select
                                                            v-model="menu.subSectionFontSize"
                                                            :options="fontSizes"
                                                            placeholder="Sélectionnez une taille"
                                                            class="style-vselect-big-qr-setting"
                                                            :disabled="campaign.id == null "
                                                        />
                                                        </b-form-group>
                                                    </div>

                                                    <div class="col-xl-3 col-md-6 col-12 pl-md-2 pl-0 pt-md-0 pt-3">
                                                        <b-form-group class="w-100 mb-0">
                                                        <v-select
                                                            v-model="menu.subSectionFontFamilyOL"
                                                            :options="fontFamilies"
                                                            label="label"
                                                            :reduce="option => option.font"
                                                            placeholder="Sélectionnez une police (Latin)"
                                                            class="style-vselect-big-qr-setting"
                                                            :disabled="campaign.id == null "
                                                            >
                                                            <template #option="{ label, font }">
                                                                <div :style="{ fontFamily: font }">
                                                                {{ label }}
                                                                </div>
                                                            </template>

                                                            <template #selected-option="{ label, font }">
                                                                <div :style="{ fontFamily: font }">
                                                                {{ label }}
                                                                </div>
                                                            </template>
                                                            </v-select>

                                                        </b-form-group>
                                                    </div>

                                                    <div class="col-xl-3 col-md-6 col-12 pl-md-2 pl-0 pt-md-0 pt-3" v-if="isLangSupported('ar')">
                                                        <b-form-group class="w-100 mb-0">
                                                        <v-select
                                                            v-model="menu.subSectionFontFamilyAR"
                                                            :options="fontFamiliesAR"
                                                            label="label"
                                                            :reduce="option => option.font"
                                                            placeholder="Sélectionnez une police (Arabe)"
                                                            class="style-vselect-big-qr-setting-ar"
                                                            :disabled="campaign.id == null "
                                                            >
                                                            <template #option="{ label, font }">
                                                                <div :style="{ fontFamily: font }">
                                                                {{ label }}
                                                                </div>
                                                            </template>

                                                            <template #selected-option="{ label, font }">
                                                                <div :style="{ fontFamily: font }">
                                                                {{ label }}
                                                                </div>
                                                            </template>
                                                            </v-select>

                                                        </b-form-group>
                                                    </div>
                                                
                                                    <div class="col-12 mt-3">
                                                        <div class="row">
                                                            <!-- Font Weight -->
                                                            <div class="mr-2 mb-3">
                                                                <span class="btn-group shadow-sm rounded-3">
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.subSectionFontWeight === 'normal' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.subSectionFontWeight = 'normal'"
                                                                >
                                                                    <i class="fas fa-font pr-1"></i>
                                                                    <strong>Normal</strong>
                                                                </button>
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.subSectionFontWeight === 'bold' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.subSectionFontWeight = 'bold'"
                                                                >
                                                                    <i class="fas fa-bold pr-1"></i>
                                                                    <strong>Gras</strong>
                                                                </button>
                                                                </span>
                                                            </div>

                                                            <!-- Text Decoration -->
                                                            <div class="mr-2 mb-3">
                                                                <span class="btn-group shadow-sm rounded-3">
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.subSectionTextDecoration === 'none' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.subSectionTextDecoration = 'none'"
                                                                >
                                                                    <i class="fas fa-ban pr-1"></i>
                                                                    <strong>Normal</strong>
                                                                </button>
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.subSectionTextDecoration === 'underline' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.subSectionTextDecoration = 'underline'"
                                                                >
                                                                    <i class="fas fa-underline pr-1"></i>
                                                                    <strong>Souligné</strong>
                                                                </button>
                                                                </span>
                                                            </div>

                                                            <!-- Font Style -->
                                                            <div class=" mb-3">
                                                                <span class="btn-group shadow-sm rounded-3">
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.subSectionFontStyle === 'normal' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.subSectionFontStyle = 'normal'"
                                                                >
                                                                    <i class="fas fa-font pr-1"></i>
                                                                    <strong>Normal</strong>
                                                                </button>
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.subSectionFontStyle === 'italic' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.subSectionFontStyle = 'italic'"
                                                                >
                                                                    <i class="fas fa-italic pr-1"></i>
                                                                    <strong>Italique</strong>
                                                                </button>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-12 col-12 text-left">

                                            <div class="row pb-2 font-size-16 mt-5">
                                                <div class="col-12 text-uppercase font-weight-bold text-info "> {{$t('campaign.label.menu.productTitle')}}</div>
                                            </div>
                                        </div>

                                        <div>

                                            <div class="col-12 text-left">
                                                <div class="row pb-2 font-size-14">
                                                    <div class="col-12 text-uppercase font-weight-bold text-dark">style </div>
                                                </div>
                                            </div>

                                            <div class="col-md-12 col-12 text-left">
                                                <div class="row">
                                                    <div class="col-xl-3 col-md-6 col-12 pr-md-2 pr-0">
                                                        <b-form-group class="w-100 mb-0">
                                                        <v-select
                                                            v-model="menu.productFontSize"
                                                            :options="fontSizes"
                                                            placeholder="Sélectionnez une taille"
                                                            class="style-vselect-big-qr-setting"
                                                            :disabled="campaign.id == null "
                                                        />
                                                        </b-form-group>
                                                    </div>

                                                    <div class="col-xl-3 col-md-6 col-12 pl-md-2 pl-0 pt-md-0 pt-3">
                                                        <b-form-group class="w-100 mb-0">
                                                        <v-select
                                                            v-model="menu.productFontFamilyOL"
                                                            :options="fontFamilies"
                                                            label="label"
                                                            :reduce="option => option.font"
                                                            placeholder="Sélectionnez une police (Latin)"
                                                            class="style-vselect-big-qr-setting"
                                                            :disabled="campaign.id == null "
                                                            >
                                                            <template #option="{ label, font }">
                                                                <div :style="{ fontFamily: font }">
                                                                {{ label }}
                                                                </div>
                                                            </template>

                                                            <template #selected-option="{ label, font }">
                                                                <div :style="{ fontFamily: font }">
                                                                {{ label }}
                                                                </div>
                                                            </template>
                                                            </v-select>

                                                        </b-form-group>
                                                    </div>

                                                    <div class="col-xl-3 col-md-6 col-12 pl-md-2 pl-0 pt-md-0 pt-3" v-if="isLangSupported('ar')">
                                                        <b-form-group class="w-100 mb-0">
                                                        <v-select
                                                            v-model="menu.productFontFamilyAR"
                                                            :options="fontFamiliesAR"
                                                            label="label"
                                                            :reduce="option => option.font"
                                                            placeholder="Sélectionnez une police (Arabe)"
                                                            class="style-vselect-big-qr-setting-ar"
                                                            :disabled="campaign.id == null "
                                                            >
                                                            <template #option="{ label, font }">
                                                                <div :style="{ fontFamily: font }">
                                                                {{ label }}
                                                                </div>
                                                            </template>

                                                            <template #selected-option="{ label, font }">
                                                                <div :style="{ fontFamily: font }">
                                                                {{ label }}
                                                                </div>
                                                            </template>
                                                            </v-select>

                                                        </b-form-group>
                                                    </div>
                                                    
                                                    <div class="col-12 mt-3">
                                                        <div class="row">
                                                            <!-- Font Weight -->
                                                            <div class="mr-2 mb-3">
                                                                <span class="btn-group shadow-sm rounded-3">
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.productFontWeight === 'normal' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.productFontWeight = 'normal'"
                                                                >
                                                                    <i class="fas fa-font pr-1"></i>
                                                                    <strong>Normal</strong>
                                                                </button>
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.productFontWeight === 'bold' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.productFontWeight = 'bold'"
                                                                >
                                                                    <i class="fas fa-bold pr-1"></i>
                                                                    <strong>Gras</strong>
                                                                </button>
                                                                </span>
                                                            </div>

                                                            <!-- Text Decoration -->
                                                            <div class="mr-2 mb-3">
                                                                <span class="btn-group shadow-sm rounded-3">
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.productTextDecoration === 'none' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.productTextDecoration = 'none'"
                                                                >
                                                                    <i class="fas fa-ban pr-1"></i>
                                                                    <strong>Normal</strong>
                                                                </button>
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.productTextDecoration === 'underline' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.productTextDecoration = 'underline'"
                                                                >
                                                                    <i class="fas fa-underline pr-1"></i>
                                                                    <strong>Souligné</strong>
                                                                </button>
                                                                </span>
                                                            </div>

                                                            <!-- Font Style -->
                                                            <div class=" mb-3">
                                                                <span class="btn-group shadow-sm rounded-3">
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.productFontStyle === 'normal' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.productFontStyle = 'normal'"
                                                                >
                                                                    <i class="fas fa-font pr-1"></i>
                                                                    <strong>Normal</strong>
                                                                </button>
                                                                <button
                                                                    
                                                                    style="height: 2.2rem;"
                                                                    class="btn btn-sm"
                                                                    :class="menu.productFontStyle === 'italic' ? 'btn-dark active' : 'btn-outline-dark'"
                                                                    @click="menu.productFontStyle = 'italic'"
                                                                >
                                                                    <i class="fas fa-italic pr-1"></i>
                                                                    <strong>Italique</strong>
                                                                </button>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        <div class="col-md-12 col-12 text-left">

                                            <div class="row pb-2 font-size-16 mt-4">
                                                <div class="col-12 text-uppercase font-weight-bold text-info "> {{$t('campaign.label.menu.socialMedia')}} </div>
                                            </div>

                                            <div class="row pb-2 mt-3">
                                                <div class="col-12 text-uppercase font-weight-bold text-dark">{{$t('campaign.label.menu.instagram')}}</div>
                                            </div>

                                            <div class="col-md-4 pr-md-2 pr-0 ">
                                                <b-form-group class="w-100 mb-0">
                                                    <b-input-group class="h-100">
                                                    <b-form-input
                                                        :placeholder="$t('campaign.label.menu.instagram')" 
                                                        :disabled="campaign.id == null "
                                                        v-model="menu.instagramUrl"
                                                        class="h-100"
                                                    />
                                                    </b-input-group>
                                                </b-form-group>
                                            </div>


                                            <div class="row pb-2 mt-3">
                                                <div class="col-12 text-uppercase font-weight-bold text-dark">{{$t('campaign.label.menu.googleReview')}}</div>
                                            </div>

                                            <div class="col-md-4 pr-md-2 pr-0 ">
                                                <b-form-group class="w-100 mb-0">
                                                    <b-input-group class="h-100">
                                                    <b-form-input
                                                        :placeholder="$t('campaign.label.menu.googleReview')" 
                                                        :disabled="campaign.id == null "
                                                        v-model="menu.googleReviewUrl"
                                                        class="h-100"
                                                    />
                                                    </b-input-group>
                                                </b-form-group>
                                            </div>
                                        </div>

                                        <div class="mt-4 col-12 text-right">
                                            <b-button variant="primary" @click="saveSettingsMenu()" class="float-sm-right font-weight-bold text-uppercase mt-4 mt-lg-0 mt-xl-0 mt-md-0 " :disabled="campaign.id == null ">
                                                {{$t("buttons.save")}}
                                            </b-button> 
                                        </div>

                                    </div>



                                </b-tab>


                                <b-tab>

                                    <template v-slot:title>
                                        <span class="font-size-16">Couleur du thème</span>
                                    </template>

                                    <div class="mx-4 text-left">

                                        <div class="row mt-2" >
                                            <ColorPickerField
                                            label="campaign.label.menu.colorBg"
                                            :showPicker.sync="showColorModalMenuBackgroundColor"
                                            :colorValue="menu.backgroundColor"
                                            :campaignId="campaign.id"
                                            :titleConfig="titleConfig"
                                            columnClass="col-md-6 col-12 my-2"
                                            @updateColor="changeMenuBackgroundColor"
                                            />

                                            <ColorPickerField
                                            label="campaign.label.menu.titlecolor"
                                            :showPicker.sync="showColorModalTitleColor"
                                            :colorValue="menu.titleFontColor"
                                            :campaignId="campaign.id"
                                            :titleConfig="titleConfig"
                                            columnClass="col-md-6 col-12 my-2"
                                            @updateColor="changeTitleColor"
                                            />

                                            <ColorPickerField
                                            label="campaign.label.menu.fontGroupColor"
                                            :showPicker.sync="showColorModalMenuGroupColor"
                                            :colorValue="menu.groupFontColor"
                                            :campaignId="campaign.id"
                                            :titleConfig="titleConfig"
                                            columnClass="col-md-6 col-12 my-2"
                                            @updateColor="changeMenuGroupColor"
                                            />

                                            <ColorPickerField
                                            label="campaign.label.menu.titleGroupColor"
                                            :showPicker.sync="showColorModalMenuGroupTitleColor"
                                            :colorValue="menu.groupTitleColor"
                                            :campaignId="campaign.id"
                                            :titleConfig="titleConfig"
                                            columnClass="col-md-6 col-12 my-2"
                                            @updateColor="changeMenuGroupTitleColor"
                                            />
                                            

                                            <ColorPickerField
                                            label="campaign.label.menu.titleSectionColor"
                                            :showPicker.sync="showColorModalMenuSectionColor"
                                            :colorValue="menu.sectionFontColor"
                                            :campaignId="campaign.id"
                                            :titleConfig="titleConfig"
                                            columnClass="col-md-6 col-12 my-2"
                                            @updateColor="changeMenuSectionColor"
                                            />

                                        
                                            <ColorPickerField
                                            label="campaign.label.menu.titleSubSectionColor"
                                            :showPicker.sync="showColorModalMenuSubSectionColor"
                                            :colorValue="menu.subSectionFontColor"
                                            :campaignId="campaign.id"
                                            :titleConfig="titleConfig"
                                            columnClass="col-md-6 col-12 my-2"
                                            @updateColor="changeMenuSubSectionColor"
                                            />

                                            <ColorPickerField
                                            label="campaign.label.menu.productTitleColor"
                                            :showPicker.sync="showColorModalTitleProductColor"
                                            :colorValue="menu.productFontColor"
                                            :campaignId="campaign.id"
                                            :titleConfig="titleConfig"
                                            columnClass="col-md-6 col-12 my-2"
                                            @updateColor="changeTitleProductColor"
                                            />

                                            <ColorPickerField
                                            label="campaign.label.menu.itemDescriptionColor"
                                            :showPicker.sync="showItemdescriptionColor"
                                            :colorValue="menu.itemDescriptionColor"
                                            :campaignId="campaign.id"
                                            :titleConfig="titleConfig"
                                            columnClass="col-md-6 col-12 my-2"
                                            @updateColor="changeItemDescriptionColor"
                                            />

                                            <ColorPickerField
                                            label="campaign.label.menu.cardTitleItemColor"
                                            :showPicker.sync="showCardTitleItemBackgroundColor"
                                            :colorValue="menu.titleItemBackgroundColor"
                                            :campaignId="campaign.id"
                                            :titleConfig="titleConfig"
                                            columnClass="col-md-6 col-12 my-2"
                                            @updateColor="changeTitleItemBackgroundColor"
                                            />
                                        </div>
                                    
                                        <div class="mt-4 col-12 text-right">
                                            <b-button variant="primary" @click="saveSettingsMenu()" class="float-sm-right font-weight-bold text-uppercase mt-4 mt-lg-0 mt-xl-0 mt-md-0 " :disabled="campaign.id == null ">
                                                {{$t("buttons.save")}}
                                            </b-button> 
                                        </div>

                                    </div>



                                </b-tab>



                                <b-tab>
                                    <template v-slot:title>
                                        <span class="font-size-16">{{ $t('campaign.label.menu.group') }}</span>
                                    </template>


                                    <div class="mx-4 text-left">

                                        <b-button variant="info" size="sm" 
                                            :disabled="campaign.id == null "
                                            class="mb-3 d-flex font-weight-bold text-uppercase" @click="addNewGroup()" style="justify-self:end">
                                                {{$t('campaign.label.menu.newGroup')}}
                                        </b-button>

                                        <div class="row w-100 m-2 p-0" v-if="menuGroups && menuGroups.length">
                                            <div v-for="group in menuGroups" :key="group.id" class="col-md-6 col-12 mb-3 d-flex align-items-center  px-2"
                                                :style="{ opacity: group.isVisible ? '1' : '0.5' }">

                                                <div class="border rounded w-100 d-flex align-items-center shadow-sm mx-2 p-2 bg-light">

                                                    <div class="flex-grow-1 d-flex align-items-center justify-content-between p-2">
                                                        <span class="font-weight-bold text-dark">{{group.priority}} {{ group.name }}</span>
                                                    </div>

                                                    <div class="d-flex align-items-center">
                                                        <img
                                                            alt="save"
                                                            width="15"
                                                            class="mr-2"
                                                            src="@/assets/icons/edit.svg"
                                                            style="cursor: pointer;"
                                                            @click="addNewGroup(group)"
                                                        />
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>


                                        <div v-else class="text-muted text-center p-2">
                                            Ce menu ne contient aucune famille.
                                        </div>
                                    </div>

                                </b-tab>

                                <b-tab >
                                    <template v-slot:title>
                                        <span class="font-size-16">{{$t('campaign.label.menu.menu')}}</span>
                                    </template>


                                    <div class="mx-4 text-left">

                                        <b-button variant="info" size="sm" class="mb-3 d-flex font-weight-bold text-uppercase"
                                        :disabled="campaign.id == null " @click="addNewSection()" style="justify-self:end">
                                            {{$t('campaign.label.menu.newSection')}}
                                        </b-button>

                                        <div v-for="(section, secIndex) in menu.menuSections" :key="secIndex" >

                                            <div   v-b-toggle="'accordion-' + secIndex" class="d-flex justify-between align-items-left mb-3 mt-3 cursor-pointer pb-3" :class="{ disabledSection: !section.isVisible }" style="border-bottom: 1px solid #ddd;">
                                                <div class="section-text flex-grow-1 text-dark text-uppercase font-weight-bold text-left font-size-18">  {{ section.name }}  
                                                </div>

                                                    <img v-if="section.isNotAvailableVirtual || section.isHiddenOnline" class="mr-2" alt="" src="@/assets/icons/globe-no-svgrepo-com.svg"  height="15"/>

                                                    <img  class="mr-2" alt="" src="@/assets/icons/edit.svg"  height="15"  style="cursor: pointer;" @click.stop="addNewSection(section)"/>

                                                <i class="fas fa-chevron-down text-info ml-2" :class="{ 'rotate-180': openSections[secIndex] }"
                                                    style="transition: transform 0.3s ease;" ></i>
                                            </div>

                                            <b-collapse  :id="'accordion-' + secIndex" accordion="main-accordion" role="tabpanel" :class="{ disabledSection: !section.isVisible }" >


                                                <div class="d-flex" style="justify-self:end">

                                                    <b-button variant="secondary" size="sm" 
                                                        :disabled="campaign.id == null "
                                                        class="mb-3 d-flex font-weight-bold text-uppercase mr-2" @click="addNewItem( null,section)" >
                                                            {{$t('campaign.label.menu.newItem')}}
                                                    </b-button>
                                                    <b-button variant="secondary" size="sm" 
                                                        :disabled="campaign.id == null "
                                                        class="mb-3 d-flex font-weight-bold text-uppercase ml-2" @click="addNewSubSection(null, section)">
                                                            {{$t('campaign.label.menu.newSubSection')}}
                                                    </b-button>

                                                </div>


                                                <div v-if="section.menuSubSection" class="mx-4" >
                                                <div v-for="(subSection, subIndex) in section.menuSubSection" :key="subIndex" >

                                                    <div   v-b-toggle="'sub-accordion-' + subIndex" class="d-flex justify-between align-items-left mb-3 mt-3 cursor-pointer pb-3"  :class="{ disabledSection: !section.isVisible || !subSection.isVisible }" style="border-bottom: 1px solid #ddd;">
                                                        <div class="section-text flex-grow-1 text-dark text-uppercase font-weight-bold text-left font-size-15">  {{ subSection.name }}  
                                                        </div>

                                                            <img v-if="subSection.isNotAvailableVirtual  || subSection.isHiddenOnline " class="mr-2" alt="" src="@/assets/icons/globe-no-svgrepo-com.svg"  height="15"/>

                                                            <img  class="mr-2" alt="" src="@/assets/icons/edit.svg"  height="15"  style="cursor: pointer;" @click.stop="addNewSubSection(subSection, section)"/>

                                                        <i class="fas fa-chevron-down text-info ml-2" :class="{ 'rotate-180': !openSubSections[`${secIndex}-${subIndex}`] }"
                                                            style="transition: transform 0.3s ease;" ></i>
                                                    </div>

                                                    <b-collapse  :id="'sub-accordion-' + subIndex" role="tabpanel" :class="{ disabledSection: !section.isVisible || !subSection.isVisible }" >


                                                        <b-button variant="secondary" size="sm" 
                                                        :disabled="campaign.id == null "
                                                        class="mb-3 d-flex font-weight-bold text-uppercase"  @click="addNewItem( null, section, subSection)" style="justify-self:end">
                                                            {{$t('campaign.label.menu.newItem')}}
                                                        </b-button>


                                                        <span class="row mt-4">

                                                            <span v-for="(item, index) in subSection.menuItem" :key="index" class="col-xl-4 col-md-6 col-12 d-flex mb-4 pl-2 pr-2">
                                                                <div class="row w-100" :class= "!item.isVisible ? 'invisibleItem' : ''">
                                                                    <div v-if="subSection.withImage" class="col-4 pr-2" @click="showMenuItemsImageOrCropperModal(item, section) " style="cursor: pointer;">
                                                                        <img alt="" style="max-width: 200px;" width="100%" height="auto" :src="'/api/image/get/menu/small/' + item.image" />
                                                                    </div>
                                                                    <div class="col-8 pl-2">
                                                                        <div >
                                                                            <div class="">
                                                                                <strong>{{ $t('campaign.label.menu.itemName') }}:</strong> {{ item.name || '-' }}
                                                                                <img  class="float-right ml-2" alt="" src="@/assets/icons/edit.svg" @click="addNewItem( item, section, subSection)"  height="15"  style="cursor: pointer;"/>
                                                                            </div>

                                                                            <div class=" mt-2">
                                                                                <strong>{{ $t('campaign.label.menu.itemDescription') }}:</strong><br>
                                                                                <div class="mb-0" v-html="item.description ? item.description.replace(/\n/g, '<br/>') : '-'"></div>
                                                                            </div>

                                                                            <div class=" mt-2 text-left">
                                                                                <strong>{{ $t('campaign.label.menu.itemPriority') }}:</strong>
                                                                                {{ item.priority != null ? item.priority : '-' }}
                                                                            </div>
                                                                            <div class="d-flex align-items-center justify-content-between">
                                                                            
                                                                            <div>
                                                                                <strong>{{ $t('campaign.label.menu.itemPrice') }}:</strong>
                                                                                {{ item.price != null ? item.price : '-' }}
                                                                            </div>

                                                                            <img
                                                                                v-if="item.isNotAvailableVirtual || item.isHiddenOnline "
                                                                                class="ml-2"
                                                                                alt="not available virtual"
                                                                                src="@/assets/icons/globe-no-svgrepo-com.svg"
                                                                                height="15"
                                                                            />

                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <span> 
                                                                </span>
                                                            </span>
                                                        </span>
                                                    </b-collapse> 
                                                </div>
                                                </div>

                                                <span class="row mt-4"   :style="{ opacity: section.menuSubSection == null || section.menuSubSection.length == 0 ? '1' : '0.5' }" >

                                                    <span v-for="(item, index) in section.menuItem" :key="index" class="col-xl-4 col-md-6 col-12 d-flex mb-4 pl-2 pr-2">
                                                        <div class="row w-100" :class= "!item.isVisible ? 'invisibleItem' : ''">
                                                            <div v-if="section.withImage" class="col-4 pr-2" @click="showMenuItemsImageOrCropperModal(item, section) " style="cursor: pointer;">
                                                                <img alt="" style="max-width: 200px;" width="100%" height="auto" :src="'/api/image/get/menu/small/' + item.image" />
                                                            </div>
                                                            <div class="col-8 pl-2">
                                                                <div >
                                                                    <div class="">
                                                                        <strong>{{ $t('campaign.label.menu.itemName') }}:</strong> {{ item.name || '-' }}
                                                                        <img  class="float-right ml-2" alt="" src="@/assets/icons/edit.svg" @click="addNewItem(item , section)"   height="15"  style="cursor: pointer;"/>
                                                                    </div>

                                                                    <div class=" mt-2">
                                                                        <strong>{{ $t('campaign.label.menu.itemDescription') }}:</strong><br>
                                                                        <div class="mb-0" v-html="item.description ? item.description.replace(/\n/g, '<br/>') : '-'"></div>
                                                                    </div>

                                                                    <div class=" mt-2 text-left">
                                                                        <strong>{{ $t('campaign.label.menu.itemPriority') }}:</strong>
                                                                        {{ item.priority != null ? item.priority : '-' }}
                                                                    </div>

                                                                    <div class="d-flex align-items-center justify-content-between">

                                                                        <div >
                                                                            <strong>{{ $t('campaign.label.menu.itemPrice') }}:</strong>
                                                                            {{ item.price != null ? item.price : '-' }}
                                                                        </div>

                                                                        
                                                                        <img
                                                                            v-if="item.isNotAvailableVirtual || item.isHiddenOnline "
                                                                            class="ml-2"
                                                                            alt="not available virtual"
                                                                            src="@/assets/icons/globe-no-svgrepo-com.svg"
                                                                            height="15"
                                                                        />
                                                                    </div>

                                                                    
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <span> 
                                                        </span>
                                                    </span>
                                                </span>
                                            </b-collapse> 
                                        </div>
                                    </div>

                                    
                                </b-tab>
                            
                            </b-tabs>
                        </div>

                    </div>     
                </div>
            </div>


            <div v-if="menu && menu.code" class="col-xl-3 col-lg-4 col-12 pl-md-2 pl-0">
                <div class="card position-sticky" style="top: 70px;">
                    <h2 class="card-title font-size-25 text-uppercase text-dark text-center pt-4 pl-4 pb-2" style="font-size:25px;">Aperçu du Menu</h2>

                    <div class="card-body p-1 " >
                        <iframe
                            v-if="menu && menu.code"
                            :key="prviewKey"
                            :src="'/qrmenu/'+menu.code"
                            width="100%"
                            height="760px"
                            frameborder="1px"
                            style="border: none;"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>



        <!-- Section Modal -->

    <b-modal
        v-model="showGroupModal"
            v-if="selectedGroup"
            :title="selectedGroup.id ? $t('campaign.label.menu.modal.editGroup') + (selectedGroup && selectedGroup.name ? selectedGroup.name : '') : $t('campaign.label.menu.modal.newGroup')"
            hide-footer
            centered
            title-class="text-primary text-uppercase"
            title-tag="h5"
            header-close-variant="danger"
            size="lg"            
            @hide="closeGroupModal()">


          <div>

            <div class="mt-2 row align-items-center" v-if="isLangSupported('fr')">
                <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                    <label class="mb-0 text-left">{{ $t('campaign.label.menu.sectionNameFR') }} :</label>
                </div>
                <div class="col-md-6 col-12">
                    <b-form-input
                    v-model="selectedGroup.nameFR"
                    :placeholder="$t('campaign.label.menu.sectionNameFR')"
                    />
                </div>
            </div>
            <div class="mt-2 row align-items-center" v-if="isLangSupported('en')">
                <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                    <label class="mb-0 text-left">{{ $t('campaign.label.menu.sectionNameEN') }} :</label>
                </div>
                <div class="col-md-6 col-12" v-if="isLangSupported('en')">
                    <b-form-input
                    v-model="selectedGroup.nameEN"
                    :placeholder="$t('campaign.label.menu.sectionNameEN')"
                    />
                </div>
            </div>
            <div class="mt-2 row align-items-center" v-if="isLangSupported('ar')">
                <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                    <label class="mb-0 text-left">{{ $t('campaign.label.menu.sectionNameAR') }} :</label>
                </div>
                <div class="col-md-6 col-12">
                    <b-form-input
                    v-model="selectedGroup.nameAR"
                    :placeholder="$t('campaign.label.menu.sectionNameAR')"
                    />
                </div>
            </div>


            <div class="row align-items-center">
                <div class="col-md-6 col-12 text-left pr-3 pt-md-0 pt-2">
                    <label class="mb-0">{{ $t('campaign.label.menu.groupPriority') }} : </label>
                </div>
                <div class="col-md-6 col-12">
                    <b-form-input
                    v-model="selectedGroup.priority"
                    class="mt-2 mr-2 text-left"
                    type="number"
                    step="1"
                    :placeholder="$t('campaign.label.menu.groupPriority')"
                    />
                </div>
            </div>
            </div>

            <div class="row">
                <div class="col-6"></div> 
                <div class="col-md-6 col-12">
                    <div class="d-flex flex-column mt-3">
                        <b-form-checkbox v-model="selectedGroup.isVisible" switch class="mb-2">
                            {{ $t('campaign.label.menu.modal.isVisible') }}
                        </b-form-checkbox>
                    </div>
                </div> 
            </div>

            <div class="mt-5 d-flex flex-column align-items-end flex-wrap">

            <div class="d-flex">
                <b-button
                v-if="selectedGroup.id"
                variant="danger"
                @click="removeGroup(selectedGroup)"
                :disabled="!campaign.id"
                class="text-uppercase ml-2 mr-2"
                >
                {{ $t("buttons.delete") }}
                </b-button>

                <b-button
                variant="primary"
                @click="saveGroup"
                :disabled="!campaign.id"
                class="text-uppercase ml-2"
                >
                {{ $t("buttons.save") }}
                </b-button>
            </div>

            <span v-if="saveError" class="text-danger small mt-1">
                {{ saveError }}
            </span>
            </div>

    </b-modal>



    <!-- Section Modal -->

    <b-modal
        v-model="showSectionModal"
            v-if="selectedSection"
            :title="selectedSection.id ? $t('campaign.label.menu.modal.editSection') + (selectedSection && selectedSection.name ? selectedSection.name : '') : $t('campaign.label.menu.modal.newSection')"
            hide-footer
            centered
            title-class="text-primary text-uppercase"
            title-tag="h5"
            header-close-variant="danger"
            size="lg"            
            @hide="closeSectionModal()">


          <div>
                <div class="row align-items-center">
                    <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                        <label class="mb-0 text-left">Familles :</label>
                    </div>
                    <div class="col-md-6 col-12">
                       
                       <v-select
                            class="style-vselect-big-qr-setting"
                            v-model="selectedSection.groups"
                            :options="menuGroups"
                            :multiple="true"
                            label="name"
                            placeholder="Sélectionner une ou plusieurs familles"
                            :disabled="campaign.id == null "
                        />
                    </div>
                </div>

                <div class="mt-2 row align-items-center">
                    <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                        <label class="mb-0 text-left">Les sous catégories :</label>
                    </div>
                    <div class="col-md-6 col-12">
                    
                        <v-select
                            v-model="selectedSection.menuSubSectionIds"
                            :options="menuSubSections"
                            :multiple="true"
                            label="name"
                            track-by="id"
                            :reduce="item => item.id"
                            placeholder="Sélectionner une ou plusieurs sous catégories"
                            :disabled="campaign.id == null"
                        >
                        <span slot="no-options">Aucune sous catégorie</span>
                        </v-select>

                    </div>
                </div>



                <div class="mt-2 row align-items-center" v-if="isLangSupported('fr')">
                    <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                        <label class="mb-0 text-left">{{ $t('campaign.label.menu.sectionNameFR') }} :</label>
                    </div>
                    <div class="col-md-6 col-12">
                        <b-form-input
                        v-model="selectedSection.nameFR"
                        :placeholder="$t('campaign.label.menu.sectionNameFR')"
                        />
                    </div>
                </div>
                <div class="mt-2 row align-items-center" v-if="isLangSupported('en')">
                    <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                        <label class="mb-0 text-left">{{ $t('campaign.label.menu.sectionNameEN') }} :</label>
                    </div>
                    <div class="col-md-6 col-12" v-if="isLangSupported('en')">
                        <b-form-input
                        v-model="selectedSection.nameEN"
                        :placeholder="$t('campaign.label.menu.sectionNameEN')"
                        />
                    </div>
                </div>
                <div class="mt-2 row align-items-center" v-if="isLangSupported('ar')">
                    <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                        <label class="mb-0 text-left">{{ $t('campaign.label.menu.sectionNameAR') }} :</label>
                    </div>
                    <div class="col-md-6 col-12">
                        <b-form-input
                        v-model="selectedSection.nameAR"
                        :placeholder="$t('campaign.label.menu.sectionNameAR')"
                        />
                    </div>
                </div>


                <div class="row align-items-center">
                    <div class="col-md-6 col-12 text-left pr-3 pt-md-0 pt-2">
                        <label class="mb-0">{{ $t('campaign.label.menu.sectionPriority') }} : </label>
                    </div>
                    <div class="col-md-6 col-12">
                        <b-form-input
                        v-model="selectedSection.priority"
                        class="mt-2 mr-2 text-left"
                        type="number"
                        step="1"
                        :placeholder="$t('campaign.label.menu.sectionPriority')"
                        />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6"></div> 
                <div class="col-md-6 col-12">
                    <div class="d-flex flex-column mt-3">
                        <b-form-checkbox
                            v-model="selectedSection.isVisible"
                            switch
                            class="mb-2"
                        >
                            {{ $t('campaign.label.menu.modal.isVisible') }}
                        </b-form-checkbox>

                        <b-form-checkbox
                            v-model="selectedSection.withImage"
                            switch
                            class="mb-2"
                        >
                            {{ $t('campaign.label.menu.modal.withImage') }}
                        </b-form-checkbox>

                        <b-form-checkbox
                            v-model="selectedSection.isNotAvailableOnline"
                            switch
                            class="mb-2"
                        >
                            {{ $t('campaign.label.menu.modal.sectionNotAvailableOnline') }}
                        </b-form-checkbox>

                        <b-form-checkbox
                            v-model="selectedSection.isNotAvailableVirtual"
                            switch
                            class="mb-2"
                        >
                            {{ $t('campaign.label.menu.modal.sectionNotAvailableVirtual') }}
                        </b-form-checkbox>
                        
                        <b-form-checkbox
                            v-model="selectedSection.isHiddenOnline"
                            switch
                        >
                            {{ $t('campaign.label.menu.modal.hideSectionOnline') }}
                        </b-form-checkbox>
                    </div>
                </div> 
            </div>

            <div class="mt-5 d-flex flex-column align-items-end flex-wrap">

            <div class="d-flex">
                <b-button
                v-if="selectedSection.id"
                variant="danger"
                @click="removeSection(selectedSection)"
                :disabled="!campaign.id"
                class="text-uppercase ml-2 mr-2"
                >
                {{ $t("buttons.delete") }}
                </b-button>

                <b-button
                variant="primary"
                @click="saveSection"
                :disabled="!campaign.id"
                class="text-uppercase ml-2"
                >
                {{ $t("buttons.save") }}
                </b-button>
            </div>

            <span v-if="saveError" class="text-danger small mt-1">
                {{ saveError }}
            </span>
            </div>


    </b-modal>



    <!-- Sub Section Modal -->

    <b-modal
        v-model="showSubSectionModal"
            v-if="selectedSubSection"
            :title="selectedSubSection.id ? $t('campaign.label.menu.modal.editSubSection') + (selectedSubSection && selectedSubSection.name ? selectedSubSection.name : '') : $t('campaign.label.menu.modal.newSubSection')"
            hide-footer
            centered
            title-class="text-primary text-uppercase"
            title-tag="h5"
            header-close-variant="danger"
            size="lg"            
            @hide="closeSubSectionModal()">


          <div>


                <div class="row align-items-center">
                    <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                        <label class="mb-0 text-left">Les catégories :</label>
                    </div>
                    <div class="col-md-6 col-12">

                       <v-select
                            class="style-vselect-big-qr-setting"
                            v-model="selectedSubSection.sections"
                            :options="menuSections"
                            :multiple="true"
                            label="name"
                            placeholder="Sélectionner une ou plusieurs catégories"
                            :disabled="campaign.id == null"
                        >
                        <span slot="no-options">Aucune catégorie</span>
                        </v-select>
                    </div>
                </div>



                <div class="mt-2 row align-items-center" v-if="isLangSupported('fr')">
                    <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                        <label class="mb-0 text-left">{{ $t('campaign.label.menu.sectionNameFR') }} :</label>
                    </div>
                    <div class="col-md-6 col-12">
                        <b-form-input
                        v-model="selectedSubSection.nameFR"
                        :placeholder="$t('campaign.label.menu.sectionNameFR')"
                        />
                    </div>
                </div>
                <div class="mt-2 row align-items-center" v-if="isLangSupported('en')">
                    <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                        <label class="mb-0 text-left">{{ $t('campaign.label.menu.sectionNameEN') }} :</label>
                    </div>
                    <div class="col-md-6 col-12" v-if="isLangSupported('en')">
                        <b-form-input
                        v-model="selectedSubSection.nameEN"
                        :placeholder="$t('campaign.label.menu.sectionNameEN')"
                        />
                    </div>
                </div>
                <div class="mt-2 row align-items-center" v-if="isLangSupported('ar')">
                    <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                        <label class="mb-0 text-left">{{ $t('campaign.label.menu.sectionNameAR') }} :</label>
                    </div>
                    <div class="col-md-6 col-12">
                        <b-form-input
                        v-model="selectedSubSection.nameAR"
                        :placeholder="$t('campaign.label.menu.sectionNameAR')"
                        />
                    </div>
                </div>


                <div class="row align-items-center">
                    <div class="col-md-6 col-12 text-left pr-3 pt-md-0 pt-2">
                        <label class="mb-0">Ordre de la sous-catégorie : </label>
                    </div>
                    <div class="col-md-6 col-12">
                        <b-form-input
                        v-model="selectedSubSection.priority"
                        class="mt-2 mr-2 text-left"
                        type="number"
                        step="1"
                        placeholder="Ordre de la sous-catégorie"
                        />
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6"></div> 
                <div class="col-md-6 col-12">
                    <div class="d-flex flex-column mt-3">
                        <b-form-checkbox
                            v-model="selectedSubSection.isVisible"
                            switch
                            class="mb-2"
                        >
                            {{ $t('campaign.label.menu.modal.isVisibleSubSection') }}
                        </b-form-checkbox>

                        <b-form-checkbox
                            v-model="selectedSubSection.withImage"
                            switch
                            class="mb-2"
                        >
                            {{ $t('campaign.label.menu.modal.withImage') }}
                        </b-form-checkbox>
                        <b-form-checkbox
                            v-model="selectedSubSection.isNotAvailableOnline"
                            switch
                            class="mb-2"
                        >
                            {{ $t('campaign.label.menu.modal.subSectionNotAvailableOnline') }}
                        </b-form-checkbox>
                        <b-form-checkbox
                            v-model="selectedSubSection.isNotAvailableVirtual"
                            switch
                            class="mb-2"
                        >
                            {{ $t('campaign.label.menu.modal.subSectionNotAvailableVirtual') }}
                        </b-form-checkbox>
                        
                        <b-form-checkbox
                            v-model="selectedSubSection.isHiddenOnline"
                            switch
                        >
                            {{ $t('campaign.label.menu.modal.hideSubSectionOnline') }}
                        </b-form-checkbox>
                    </div>
                </div> 
            </div>

            <div class="mt-5 d-flex flex-column align-items-end flex-wrap">

            <div class="d-flex">
                <b-button
                v-if="selectedSubSection.id"
                variant="danger"
                @click="removeSubSection(selectedSubSection, selectedSection)"
                :disabled="!campaign.id"
                class="text-uppercase ml-2 mr-2"
                >
                {{ $t("buttons.delete") }}
                </b-button>

                <b-button
                variant="primary"
                @click="saveSubSection"
                :disabled="!campaign.id"
                class="text-uppercase ml-2"
                >
                {{ $t("buttons.save") }}
                </b-button>
            </div>

            <span v-if="saveError" class="text-danger small mt-1">
                {{ saveError }}
            </span>
            </div>


    </b-modal>




    <!-- Image Modal  -->
    <b-modal
        v-model="showImagesModal"
            v-if="showImagesModal"
            :title="$t('campaign.label.menu.modal.imagesList')"
            hide-footer
            centered
            title-class="text-primary text-uppercase"
            title-tag="h5"
            header-close-variant="danger"
            size="lg">

            <div class="zoom-container">

            <div v-if="selectedItem && selectedItem.imagesCode && selectedItem.imagesCode.length != 0 " class="mt-3 mb-3" >

                <div class="row  "  >
                <div  v-for="(image , index) in  selectedItem.imagesCode"  :key="index"  class="col-4 pr-2 pb-2 text-center">
                    <div  class="row">
                    <div  v-if="showMenuItemImagePriorityAtIndex == index" class="col-3" /> 

                    <div  v-if="showMenuItemImagePriorityAtIndex == index" > 
                        <div class="input-group input-group-sm pull-right mb-0 float-center" style="width: 8em;"  >
                            <b-form-input v-model.number="selectedItem.imagesPriority[index]" type="number" name="number" size="sm" class="no-shadow p-1" @keyup.native.enter="saveMenuItemImagepriority(image , index)"></b-form-input>
                                <div class="input-group-append"  size="sm" >
                                    <b-button variant="link"  size="sm" class="input-group-text text-dark" @click="saveMenuItemImagepriority(image, index)" ><i  class="fas fa-save font-size-14"></i></b-button>
                                </div>
                                <div class="input-group-append"  size="sm" >
                                    <b-button variant="link"  size="sm" class="input-group-text text-dark" @click="cancelEditMenuItemImagePriority()" ><i  class="fas fa-times font-size-14"></i></b-button>
                                </div>
                            </div>
                    </div>
                    
                    <div v-else class="col-12">
                        <span class="badge font-size-11 pt-1 m-1 w-5" style="outline: 1px solid grey;">
                        <span> Ordre : <strong>{{ selectedItem.imagesPriority[index] }} </strong> </span>
                        <img  class="icontrash ml-2" width="12" alt="" src="@/assets/icons/edit.svg" @click="changeMenuItemImagePriority(index)"  style="cursor: pointer;"/>
                        </span>
                    </div>
                    </div>
                    <img v-bind:src="'/api/image/get/menu/small/' + image"  alt class="mt-2"  style="max-width: 400px; cursor: pointer;"  width="100%" height="auto"  @click="editImageMenuItem(selectedItem , image, selectedItem.imagesPriority[index] )"  />
                </div>
                </div>
            </div>

                <div class="row">
                  <div class="col-md-6 col-12 text-md-left text-center">
                      <b-button variant="outline-info" class="mt-2"  @click="openCropperImageModel()">
                          <i class="fas fa-upload font-size-12 align-middle mr-2"></i> <span class="font-weight-bold font-size-12">Ajouter Image</span>
                      </b-button>
                  </div>
  
  
                  <div class="col-md-6 col-12 text-md-right text-center">
                      <b-button variant="outline-danger" class="mt-2" @click="showImagesModal = false"  >
                          <i class="fas fa-times font-size-12 align-middle mr-2"></i> <span class="font-weight-bold font-size-12">Annuler</span>
                      </b-button>
                  </div>
              </div>

            </div>

    </b-modal>

    <!-- Cropper Modal  -->
       <b-modal
        v-model="showCropedImageModal"
            v-if="showCropedImageModal"
            :title="$t('campaign.label.menu.modal.croppedImage')"
            hide-footer
            centered
            title-class="text-primary text-uppercase"
            title-tag="h5"
            header-close-variant="danger"
            size="md">

            <div class="zoom-container">

            <div class="text-center  p-2">
                <cropper
                    class="cropper"
                    :src="importedImageUrl"
                    
                    :stencil-size="{ 
                        width: 450,
                        height: 600
                    }"
                
                    :stencil-props="{
                        handlers: {},
                        movable: false,
                        resizable: false,
                    }"

                    image-restriction="stencil"
                    @change="change"
                    @ready="imageReady"

                /> 


            </div>

            <div class="col-12 text-center">
            <b-form-group
                class="text-dark font-weight-bold"
                :label="$t('campaign.text.bannerType')"
                label-for=""
            >
                <vue2Dropzone
                ref="dropzone"
                id="dropzone"
                class="m-0 p-0 m-md-2 p-md-1"
                :use-custom-slot="true"
                :options="dropzoneOptions"
                @vdropzone-file-added="onImageUploadDragAndDrop"
                >
                <div class="dropzone-custom-content text-center p-3">
                    <img alt="upload" width="80px" src="@/assets/icons/cloud-upload.svg" />
                    <h4 class="mb-0">{{ $t('parameters.dropImage') }}</h4>
                    <h5 class="text-warning font-size-9 text-Center mt-1">
                    {{ $t('parameters.imageSize') }}
                    </h5>
                </div>
                </vue2Dropzone>
            </b-form-group>
            </div>

            <b-alert show variant="warning" class="text-justify">
                <i class="mdi mdi-alert-outline mr-2"></i>Il est fortement recommandé d'utiliser des images de dimensions <span class="font-weight-bold">450×600 px</span> et dont la taille ne dépasse pas <span class="font-weight-bold">2 Mo</span>.
            </b-alert>
            
            <b-alert show variant="warning" class="text-justify">
                <i class="mdi mdi-alert-outline mr-2"></i>Les types supportés sont <span class="font-weight-bold"> PNG </span>et <span class="font-weight-bold">JPG</span>. 
            </b-alert>

                <input 
                    type="file" 
                    @change="onImageUpload"
                    ref="imageInput"
                    style="display:none"/>


                <div class="row">
                    <div class="col-md-4 col-12 text-md-left text-center">
                        <b-button variant="outline-info"   @click="$refs.imageInput.click()">
                            <i class="fas fa-upload font-size-12 align-middle mr-2"></i> <span class="font-weight-bold font-size-12">Parcourir</span>
                        </b-button>
                    </div>

                    <div class="col-md-4 col-12 text-center ">
                        <b-button v-if="this.oldImageName" variant="outline-danger"  @click="deleteImage()">
                          <i class="fas fa-times font-size-12 align-middle mr-2"></i> <span class="font-weight-bold font-size-12">Supprimer</span>
                      </b-button>
                  </div>

                    <div class="col-md-4 col-12 text-md-right text-center ">
                    <b-button variant="outline-success"  @click="validateImage()"  :disabled="!this.isImageReady || this.validateImageLoading">
                            <i class="fas fa-solid fa-check font-size-12 align-middle mr-2"></i> <span class="font-weight-bold font-size-12">Valider</span>
                        </b-button>
                    </div>

                </div>
            </div>

    </b-modal>

    <!-- Item Modal  -->

    <b-modal
        v-model="showItemModal"
            v-if="selectedItem"
            :title="selectedItem.id ? $t('campaign.label.menu.modal.editItem') + (selectedItem.name ?  selectedItem.name : '') : $t('campaign.label.menu.modal.newItem')"
            hide-footer
            centered
            title-class="text-primary text-uppercase"
            title-tag="h5"
            header-close-variant="danger"
            size="lg"
            @hide="closeItemModal()">

            <div class="row mt-3">
                <div class="col-6"></div> 
                <div class="col-md-6 col-12">
                        <b-form-checkbox
                            v-model="selectedItem.isVisible"
                            switch
                            class="mb-2"
                        >
                            {{ $t('campaign.label.menu.modal.isItemVisible') }}
                        </b-form-checkbox>
                        <b-form-checkbox
                            v-model="selectedItem.isNotAvailableOnline"
                            switch
                            class="mb-2"
                        >
                            {{ $t('campaign.label.menu.modal.itemNotAvailableOnline') }}
                        </b-form-checkbox>
                        <b-form-checkbox
                            v-model="selectedItem.isNotAvailableVirtual"
                            switch
                            class="mb-2"
                        >
                            {{ $t('campaign.label.menu.modal.itemNotAvailableVirtual') }}
                        </b-form-checkbox>
                        
                        <b-form-checkbox
                            v-model="selectedItem.isHiddenOnline"
                            switch
                        >
                            {{ $t('campaign.label.menu.modal.hideItemOnline') }}
                        </b-form-checkbox>
                </div> 
            </div>


            
            <div class="mt-2 row align-items-center">
                <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                    <label class="mb-0 text-left">Les sous catégories :</label>
                </div>
                <div class="col-md-6 col-12">      
                
                    <v-select
                        v-model="selectedItem.menuSubSection"
                        :options="menuSubSections"
                        label="name"
                        track-by="id"
                        placeholder="Sélectionner une ou plusieurs sous catégories"
                        :disabled="campaign.id == null ||selectedItem.menuSubSection == null"
                    >
                    <span slot="no-options">Aucune sous catégorie</span>
                    </v-select>

                </div>
            </div>

           <div>

                <div class="row align-items-center mt-2" v-if="isLangSupported('fr')">
                <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                    <label class="mb-0 text-left">{{ $t('campaign.label.menu.itemNameFR') }} :</label>
                </div>
                <div class="col-md-6 col-12">
                    <b-form-input
                    v-model="selectedItem.nameFR"
                    :placeholder="$t('campaign.label.menu.itemNameFR')"
                    />
                </div>
                </div>

                <div class="row align-items-center mt-2" v-if="isLangSupported('en')">
                <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                    <label class="mb-0 text-left">{{ $t('campaign.label.menu.itemNameEN') }} :</label>
                </div>
                <div class="col-md-6 col-12">
                    <b-form-input
                    v-model="selectedItem.nameEN"
                    :placeholder="$t('campaign.label.menu.itemNameEN')"
                    />
                </div>
                </div>

                <div class="row align-items-center mt-2" v-if="isLangSupported('ar')">
                <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                    <label class="mb-0 text-left">{{ $t('campaign.label.menu.itemNameAR') }} :</label>
                </div>
                <div class="col-md-6 col-12">
                    <b-form-input
                    v-model="selectedItem.nameAR"
                    :placeholder="$t('campaign.label.menu.itemNameAR')"
                    />
                </div>
                </div>

                <div class="row align-items-center mt-2" v-if="isLangSupported('fr')">
                    <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                        <label class="mb-0 text-left">{{ $t('campaign.label.menu.itemDescriptionFR') }} :</label>
                    </div>
                    <div class="col-md-6 col-12">
                        <b-form-textarea
                        v-model="selectedItem.descriptionFR"
                        :placeholder="$t('campaign.label.menu.itemDescriptionFR')"
                        rows="5"
                        />
                    </div>
                    </div>

                    <div class="row align-items-center mt-2" v-if="isLangSupported('en')">
                    <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                        <label class="mb-0 text-left">{{ $t('campaign.label.menu.itemDescriptionEN') }} :</label>
                    </div>
                    <div class="col-md-6 col-12">
                        <b-form-textarea
                        v-model="selectedItem.descriptionEN"
                        :placeholder="$t('campaign.label.menu.itemDescriptionEN')"
                        rows="5"
                        />
                    </div>
                    </div>

                    <div class="row align-items-center mt-2" v-if="isLangSupported('ar')">
                    <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                        <label class="mb-0 text-left">{{ $t('campaign.label.menu.itemDescriptionAR') }} :</label>
                    </div>
                    <div class="col-md-6 col-12">
                        <b-form-textarea
                        v-model="selectedItem.descriptionAR"
                        :placeholder="$t('campaign.label.menu.itemDescriptionAR')"
                        rows="5"
                        />
                    </div>
                    </div>


                <div class="row align-items-center">
                    <div class="col-md-6 col-12 text-left pr-3 pt-md-0 pt-2 ">
                        <label class="mb-0">{{ $t('campaign.label.menu.itemPrice') }} : </label>
                    </div>
                    <div class="col-md-6 col-12">
                        <b-form-input
                        v-model="selectedItem.priceAsFloat"
                        class="mt-2 mr-2 text-left"
                        type="number"
                        step="0.01"
                        :placeholder="$t('campaign.label.menu.itemPrice')"
                        />
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col-md-6 col-12 text-left pr-3 pt-md-0 pt-2">
                        <label class="mb-0">{{ $t('campaign.label.menu.itemPriority') }} : </label>
                    </div>
                    <div class="col-md-6 col-12">
                        <b-form-input
                        v-model="selectedItem.priority"
                        class="mt-2 mr-2 text-left"
                        type="number"
                        step="0.01"
                        :placeholder="$t('campaign.label.menu.itemPriority')"
                        />
                    </div>
                </div>
            </div>

             <div v-if="(selectedSection && selectedSection.withImage && !selectedSubSection.id) || (selectedSubSection && selectedSubSection.withImage )  " class="row align-items-center mt-4">

                    <div class="col-md-6 col-12 d-flex justify-content-start pb-md-0 pb-2 pt-md-0 pt-2">
                        <label class="mb-0 text-left">{{ $t('campaign.label.menu.modal.itemImage') }} :</label>
                    </div>
                    <div class="col-md-6 col-12">
                        <b-button variant="secondary" class="w-100 text-uppercase"
                         @click="showMenuItemsImageModal(selectedItem)"
                        >{{  $t('campaign.label.menu.modal.displayImages') }}</b-button>
                    </div>
                </div>

           <div class="mt-5 d-flex flex-column align-items-end flex-wrap">

            <div class="d-flex">
                <b-button
                v-if="selectedItem.id"
                variant="danger"
                @click="removeItem(selectedItem.id)"
                :disabled="!campaign.id"
                class="text-uppercase ml-2 mr-2"
                >
                {{ $t("buttons.delete") }}
                </b-button>

                <b-button
                variant="primary"
                @click="saveItem(selectedSection.id, selectedItem.id, getSubSectionId(selectedItem, selectedSubSection))"
                :disabled="!campaign.id"
                class="text-uppercase ml-2"
                >
                {{ $t("buttons.save") }}
                </b-button>
            </div>

            <span v-if="saveError" class="text-danger small mt-1">
                {{ saveError }}
            </span>

            </div>
    </b-modal>
    </div>
</template>


<style scoped>
.color-picker {
    width: 24px;
    height: 24px;
    cursor: pointer;
    border-radius: 50%; /* Makes it round */
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5); /* Adds a shadow */
    transition: transform 0.3s ease; /* Adds a smooth transition effect */
}

.color-picker:hover {
    transform: scale(1.1); /* Scales up the size on hover */
}


::v-deep .vue-input-tag-wrapper .new-tag{
    margin-left: 10px;
    font-family: "Cantarell", "Poppins", sans-serif;

    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    
    padding: 0.47rem 0.75rem;
    font-size: 0.8125rem;

}

.invisibleItem {
    padding: 12px 16px;
    border-radius: 8px;
    background: #e0e0e0;
    color: #888;
    opacity: 0.6;
    filter: grayscale(100%);
    font-style: italic;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    border: 1px solid #ccc;
    transition: all 0.3s ease;
    user-select: none;
    cursor: not-allowed;
}


.disabledSection {
  opacity: 0.4;
  filter: grayscale(100%);
}


</style>


<style scoped>
::v-deep .style-vselect-big-qr-setting .vs__dropdown-toggle {
  height: 100%;
  min-height: 38px;
  align-items: center;
  display: flex;
}

::v-deep .style-vselect-big-qr-setting-ar .vs__dropdown-toggle {
  height: 100%;
  min-height: 38px;
  align-items: center;
  display: flex;
}

::v-deep .style-vselect-big-qr-setting-ar .vs__dropdown-menu {
  font-family: 'Amiri', 'Tajawal', 'Noto Sans Arabic', sans-serif;
  direction: rtl;
  text-align: right;
}

::v-deep .style-vselect-big-qr-setting-ar .vs__search{
    color: #9fa2b0;
}

::v-deep .style-vselect-big-qr-setting .vs__search{
    color: #9fa2b0;
}

::v-deep .ql-container {
  max-height: 150px !important;
}

::v-deep .ql-editor {
  height: 150px !important;
  
}


::v-deep  .nav-tabs-custom .nav-item{
    margin-top: 10px !important;

}

</style>
<style>
@import url('https://fonts.googleapis.com/css2?family=Amiri:ital,wght@0,400;0,700;1,400;1,700&family=Borel&family=Fustat:wght@200..800&family=Katibeh&family=Lateef:wght@200;300;400;500;600;700;800&family=Mada:wght@200..900&family=Marhey:wght@300..700&family=Markazi+Text:wght@400..700&family=Noto+Kufi+Arabic:wght@100..900&family=Noto+Sans+Arabic:wght@100..900&family=Pacifico&family=Scheherazade+New:wght@400;500;600;700&family=Sour+Gummy:ital,wght@0,100..900;1,100..900&family=Tajawal:wght@200;300;400;500;700;800;900&family=Zain:ital,wght@0,200;0,300;0,400;0,700;0,800;0,900;1,300;1,400&display=swap');
</style>